<template>
  <v-container class="mt-5 ml-2" fluid>
    <v-row v-if="tieneAccesoReporteSatisfaccion">
      <v-col cols="12">
				<v-card class="shadowCard">
					<v-card-title class="text-subtitle-1">
					  {{ modoSoloAvance ? 'Avance encuesta de satisfacción' : 'Encuesta de satisfacción' }}
					  <v-spacer></v-spacer>
	      		<v-menu
							v-if="!modoSoloAvance"
							offset-y
							left
							:disabled="cargar"
						>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									color="indigo"
									dark
									small
									tile
									class="mr-2"
									v-bind="attrs"
									v-on="on"
									:disabled="cargar"
								>
									<v-icon small left>mdi-chart-box-outline</v-icon>
									Resúmenes
									<v-icon small right>mdi-menu-down</v-icon>
								</v-btn>
							</template>
							<v-list dense>
								<v-list-item
									:disabled="cargar"
									@click="abrirComparativoParticipacion()"
								>
									<v-list-item-icon class="mr-2">
										<v-icon small>mdi-compare</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Resumen Comparativo de Participación</v-list-item-title>
										<v-list-item-subtitle>
											{{
												cargandoComparativo
													? 'Cargando…'
													: (comparativoParticipacion
														? etiquetaComparativoCorto
														: 'Ciclo anterior vs consultado')
											}}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-list-item
									:disabled="cargar || !tieneCalificacionGlobalPreguntas"
									@click="abrirCalificacionGlobalPreguntas()"
								>
									<v-list-item-icon class="mr-2">
										<v-icon small>mdi-help-circle-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Calificación global por pregunta</v-list-item-title>
										<v-list-item-subtitle>
											{{
												cargandoComparativo
													? 'Cargando…'
													: (etiquetaComparativoPreguntas || 'Ciclo anterior vs consultado')
											}}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
								<v-list-item
									:disabled="cargar || !tienePromedioCalificacionSucursal"
									@click="abrirPromedioCalificacionSucursal()"
								>
									<v-list-item-icon class="mr-2">
										<v-icon small>mdi-store-outline</v-icon>
									</v-list-item-icon>
									<v-list-item-content>
										<v-list-item-title>Promedio de calificación por sucursal</v-list-item-title>
										<v-list-item-subtitle>
											{{
												cargandoComparativo
													? 'Cargando…'
													: (etiquetaComparativoSucursal || 'Ciclo anterior vs consultado')
											}}
										</v-list-item-subtitle>
									</v-list-item-content>
								</v-list-item>
							</v-list>
						</v-menu>
	      		<v-btn
							v-if="!modoSoloAvance"
							color="teal"
							dark
							:disabled="!avancePorSucursal.length || cargar"
							@click="dialogAvanceSucursal = true"
							small
							tile
							class="mr-2"
						>
							<v-icon small left>mdi-store-marker</v-icon>
							Reporte sucursal
						</v-btn>
	      		<v-btn
							v-if="!modoSoloAvance"
							color="success"
							dark
							:disabled="!tieneDatosReporte || cargar"
							@click="exportarExcelReporte()"
							small
							tile
							class="mr-2"
						>
							<v-icon small left>mdi-microsoft-excel</v-icon>
							Excel
						</v-btn>
	      		<v-btn
							color="primary"
							dark
							@click="initialize()"
							small
							tile
						>
							Actualizar
						</v-btn>
					</v-card-title>
					<v-card-text >

		      	<v-row>
		      		<v-col cols="12" sm="6" lg="4" xl="3">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="ciclo"
                  :items="ciclos"
                  label="Selecciona ciclo"
                  item-text="ciclo"
                  item-value="id_ciclo"
                  return-object
                >
                </v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
              	<v-radio-group
						      v-model="opEscuela"
						      row
						    >
						      <v-radio
						        label="Inbi"
						        :value="1"
						      ></v-radio>
						      <v-radio
						        label="Fast"
						        :value="2"
						      ></v-radio>
						    </v-radio-group>
              </v-col>
							<v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="filtroPlantel"
                  :items="planteles"
                  label="Sucursal"
                  item-text="plantel"
                  item-value="id_plantel"
                  :disabled="!ciclo"
                >
                </v-autocomplete>
              </v-col>
							<v-col cols="12" sm="6" md="3" lg="2">
                <v-autocomplete
                  filled
                  dense
                  clearable
                  v-model="filtroNivelReporte"
                  :items="niveles"
                  label="Nivel"
                  item-text="nivel"
                  item-value="id_nivel"
                  :disabled="!ciclo"
                >
                </v-autocomplete>
              </v-col>
		      		<v-spacer></v-spacer>
							<v-col cols="12" sm="6" md="4" lg="3" xl="3" class="pb-0">
			          <v-text-field
			            v-model="search"
			            dense
			            filled
			            label="Buscar"
			            append-icon="mdi-magnify"
			          ></v-text-field>  
			        </v-col>
		      	</v-row>

						<v-row v-if="!modoSoloAvance" class="mb-2">
							<v-col cols="12" sm="6" md="4" lg="2">
								<v-card :color="semaforoPromedioGeneral.background" class="pa-3 resumen-card" flat>
									<v-icon :color="semaforoPromedioGeneral.color" size="28" class="mb-1 d-block text-center">mdi-traffic-light</v-icon>
									<div class="d-flex align-center justify-center text-h5 font-weight-bold">
										<v-icon small :color="semaforoPromedioGeneral.color" class="mr-2">mdi-circle</v-icon>
										{{ promedioGeneralDisplay }}
									</div>
									<div class="text-caption text-center">Promedio general</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="2">
								<v-card color="blue lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="blue darken-2" size="28" class="mb-1 d-block text-center">mdi-account-group</v-icon>
									<div class="text-h5 font-weight-bold text-center">{{ porcentajeParticipacionDisplay }}%</div>
									<div class="text-caption text-center">Participación</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="3">
								<v-card color="red lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="red darken-2" size="28" class="mb-1 d-block text-center">mdi-alert-circle</v-icon>
									<div class="text-subtitle-1 font-weight-bold text-center text-truncate">{{ peorCategoriaDisplay }}</div>
									<div class="text-caption text-center">Peor categoría</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="3">
								<v-card color="green lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="green darken-2" size="28" class="mb-1 d-block text-center">mdi-star-circle</v-icon>
									<div class="text-subtitle-1 font-weight-bold text-center text-truncate">{{ mejorCategoriaDisplay }}</div>
									<div class="text-caption text-center">Mejor categoría</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="6" md="4" lg="2">
								<v-card color="orange lighten-5" class="pa-3 resumen-card" flat>
									<v-icon color="orange darken-2" size="28" class="mb-1 d-block text-center">mdi-map-marker-alert</v-icon>
									<div class="text-subtitle-1 font-weight-bold text-center text-truncate">{{ sucursalCriticaDisplay }}</div>
									<div class="text-caption text-center">Sucursal crítica</div>
								</v-card>
							</v-col>
						</v-row>

		        <v-tabs
		          v-if="!modoSoloAvance"
		          v-model="tab"
		          dense
		          align-with-title
		        >
		          <v-tabs-slider></v-tabs-slider>

		          <v-tab v-if="getdatosUsuarioERPERP.idpuesto != 82">Nivel y Cat.</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.idpuesto != 82">Categoría</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.idpuesto != 82">Suc y Cat.</v-tab>
		          <v-tab>Teacher y Categoría</v-tab>
		          <v-tab>Comentarios</v-tab>
		          <v-tab>Avance</v-tab>
		          <v-tab>Faltantes</v-tab>
		          <v-tab v-if="getdatosUsuarioERPERP.idpuesto != 82">Preguntas</v-tab>
		        </v-tabs>

				

				

		        <v-tabs-items v-if="!modoSoloAvance" v-model="tab">

		        	<!-- Nivel y Cat. -->
				      <v-tab-item v-if="getdatosUsuarioERPERP.idpuesto != 82">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersNivel"
						          :items="nivel"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Categoria -->
				      <v-tab-item v-if="getdatosUsuarioERPERP.idpuesto != 82">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersCategoria"
						          :items="categorias"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Suc y Cat -->
				      <v-tab-item v-if="getdatosUsuarioERPERP.idpuesto != 82">
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersDepartamento"
						          :items="departamentos"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Teacher y Categoria -->
				      <v-tab-item>
				        <v-card flat>
				        	<v-card-title primary-title>
				        	  Competencia de los profesores: ¿Qué tan preparados y capacitados consideras que están los profesores para enseñar el idioma inglés?
				        	</v-card-title>
				          <v-card-text>
						        <v-data-table
						          :headers="headersTeachers"
						          :items="teachers"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Comentarios -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text>
						        <v-data-table
						          :headers="headersComentario"
						          :items="comentarios"
						          class="elevation-0"
						          dense
						          :search="search"
											no-data-text="Sin comentarios abiertos"
						        >
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Avance -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text>
				          	<v-row class="mb-2">
				          		<v-col cols="12" sm="4" md="3">
				          			<v-card color="green lighten-5" class="pa-3 resumen-card" flat>
				          				<div class="text-h6 font-weight-bold text-center green--text text--darken-2">{{ avanceConteo.encuestados }}</div>
				          				<div class="text-caption text-center">Contestaron</div>
				          			</v-card>
				          		</v-col>
				          		<v-col cols="12" sm="4" md="3">
				          			<v-card color="orange lighten-5" class="pa-3 resumen-card" flat>
				          				<div class="text-h6 font-weight-bold text-center orange--text text--darken-3">{{ avanceConteo.pendientes }}</div>
				          				<div class="text-caption text-center">Pendientes</div>
				          			</v-card>
				          		</v-col>
				          		<v-col cols="12" sm="4" md="3">
				          			<v-card color="blue lighten-5" class="pa-3 resumen-card" flat>
				          				<div class="text-h6 font-weight-bold text-center blue--text text--darken-2">{{ avanceConteo.incidencias }}</div>
				          				<div class="text-caption text-center">Con incidencia</div>
				          			</v-card>
				          		</v-col>
				          	</v-row>
						        <v-data-table
						          :headers="headersAvance"
						          :items="avanceAlumnos"
						          class="elevation-0"
						          dense
						          :search="search"
						          item-key="id_alumno"
						          no-data-text="Sin alumnos para el filtro seleccionado"
						        >
						        	<template v-slot:item.encuestado="{ item }">
						        		<v-btn
						        			small
						        			tile
						        			:color="item.encuestado ? 'success' : 'orange darken-1'"
						        			dark
						        			disabled
						        			class="avance-estatus-btn"
						        		>
						        			<v-icon left small>{{ item.encuestado ? 'mdi-check-circle' : 'mdi-clock-outline' }}</v-icon>
						        			{{ item.encuestado ? 'Contestó' : 'Pendiente' }}
						        		</v-btn>
						        	</template>
						        	<template v-slot:item.incidencia="{ item }">
						        		<div v-if="item.encuestado" class="text-caption grey--text">—</div>
						        		<div v-else-if="item.id_incidencia" class="d-flex align-center flex-wrap">
						        			<v-btn
						        				small
						        				tile
						        				color="teal"
						        				dark
						        				@click="abrirIncidencia( item, true )"
						        			>
						        				<v-icon left small>mdi-file-document-check</v-icon>
						        				Ver incidencia
						        			</v-btn>
						        		</div>
						        		<v-btn
						        			v-else
						        			small
						        			tile
						        			outlined
						        			color="orange darken-2"
						        			@click="abrirIncidencia( item, false )"
						        		>
						        			<v-icon left small>mdi-alert-circle-outline</v-icon>
						        			Registrar
						        		</v-btn>
						        	</template>
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				      <!-- Faltantes -->
				      <v-tab-item>
				        <v-card flat>
				          <v-card-text class="black--text">
				          	<v-row>
				          		<v-col cols="12">
				          			<div>
				          				<b>Total: {{ alumnos }}</b><br/>
				          				<b>Faltan: {{ faltantes.length }}</b><br/>
				          				<b>Avance: {{ avanceFaltantes }} % </b>
				          				<span v-if="cicloSiguiente" class="d-block text-caption mt-1">
				          					Estatus sig. ciclo referencia: {{ cicloSiguiente }}
				          				</span>
				          			</div>
				          		</v-col>
				          	</v-row>
						        <v-data-table
						          :headers="headersFaltantes"
						          :items="faltantes"
						          class="elevation-0"
						          dense
						          :search="search"
						        >
						        	<template v-slot:item.estatus_siguiente_ciclo="{ item }">
						        		<div class="estatus-ciclo-cell">
							        		<v-chip
							        			small
							        			label
							        			class="estatus-ciclo-chip ma-0"
							        			:color="item.en_siguiente_ciclo ? 'green lighten-4' : 'grey lighten-4'"
							        			:text-color="item.en_siguiente_ciclo ? 'green darken-3' : 'grey darken-2'"
							        			:title="item.estatus_siguiente_ciclo"
							        		>
							        			<v-icon
							        				left
							        				x-small
							        				:color="item.en_siguiente_ciclo ? 'green darken-2' : 'grey darken-1'"
							        			>
							        				{{ item.en_siguiente_ciclo ? 'mdi-check-circle' : 'mdi-minus-circle-outline' }}
							        			</v-icon>
							        			{{ etiquetaEstatusSiguienteCiclo( item ) }}
							        		</v-chip>
						        		</div>
						        	</template>
						        </v-data-table>
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

					  <v-tab-item v-if="getdatosUsuarioERPERP.idpuesto != 82">
				        <v-card flat>
				          <v-card-text>

							<div style="display: flex;">

								<v-select
									style="max-width: 10rem; margin-right: 2rem;"
									  v-model="categoriaSeleccionada"
									  :items="categoriasFiltradas"
									  label="Filtrar por categoría"
									  clearable
									  dense
									  class="mb-3"
								/>
	
								<v-select
									style="max-width: 10rem;"
									  v-model="nivelSeleccionado"
									  :items="nivelesFiltradas"
									  label="Filtrar por nivel"
									  clearable
									  dense
									  class="mb-3"
								/>

							</div>

							<v-data-table
								:headers="headersPreguntas"
								:items="preguntasFiltradas"
								class="elevation-0"
								dense
							>
							</v-data-table>
							
				          </v-card-text>
				        </v-card>
				      </v-tab-item>

				</v-tabs-items>

				<!-- Vista restringida: solo Avance (Recepción / Programador de producto) -->
				<v-card v-if="modoSoloAvance" flat>
					<v-card-text>
						<v-row class="mb-2">
							<v-col cols="12" sm="4" md="3">
								<v-card color="green lighten-5" class="pa-3 resumen-card" flat>
									<div class="text-h6 font-weight-bold text-center green--text text--darken-2">{{ avanceConteo.encuestados }}</div>
									<div class="text-caption text-center">Contestaron</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="4" md="3">
								<v-card color="orange lighten-5" class="pa-3 resumen-card" flat>
									<div class="text-h6 font-weight-bold text-center orange--text text--darken-3">{{ avanceConteo.pendientes }}</div>
									<div class="text-caption text-center">Pendientes</div>
								</v-card>
							</v-col>
							<v-col cols="12" sm="4" md="3">
								<v-card color="blue lighten-5" class="pa-3 resumen-card" flat>
									<div class="text-h6 font-weight-bold text-center blue--text text--darken-2">{{ avanceConteo.incidencias }}</div>
									<div class="text-caption text-center">Con incidencia</div>
								</v-card>
							</v-col>
						</v-row>
						<v-data-table
							:headers="headersAvance"
							:items="avanceAlumnos"
							class="elevation-0"
							dense
							:search="search"
							item-key="id_alumno"
							no-data-text="Sin alumnos para el filtro seleccionado"
						>
							<template v-slot:item.encuestado="{ item }">
								<v-btn
									small
									tile
									:color="item.encuestado ? 'success' : 'orange darken-1'"
									dark
									disabled
									class="avance-estatus-btn"
								>
									<v-icon left small>{{ item.encuestado ? 'mdi-check-circle' : 'mdi-clock-outline' }}</v-icon>
									{{ item.encuestado ? 'Contestó' : 'Pendiente' }}
								</v-btn>
							</template>
							<template v-slot:item.incidencia="{ item }">
								<div v-if="item.encuestado" class="text-caption grey--text">—</div>
								<div v-else-if="item.id_incidencia">
									<v-btn
										small
										tile
										color="teal"
										dark
										@click="abrirIncidencia( item, true )"
									>
										<v-icon left small>mdi-file-document-check</v-icon>
										Ver incidencia
									</v-btn>
								</div>
								<v-btn
									v-else
									small
									tile
									outlined
									color="orange darken-2"
									@click="abrirIncidencia( item, false )"
								>
									<v-icon left small>mdi-alert-circle-outline</v-icon>
									Registrar
								</v-btn>
							</template>
						</v-data-table>
					</v-card-text>
				</v-card>



		      </v-card-text>
				</v-card> 
			</v-col>
		</v-row>

		<!-- Dialog reporte por sucursal -->
		<v-dialog v-model="dialogAvanceSucursal" max-width="900px" scrollable>
			<v-card>
				<v-card-title class="text-subtitle-1">
					Avance por sucursal
					<v-spacer></v-spacer>
					<v-btn
						color="success"
						dark
						small
						:disabled="!avancePorSucursal.length"
						@click="exportarExcelAvanceSucursal()"
					>
						<v-icon small left>mdi-microsoft-excel</v-icon>
						Excel
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-data-table
						:headers="headersAvanceSucursal"
						:items="avancePorSucursal"
						class="elevation-0"
						dense
						hide-default-footer
						:items-per-page="-1"
					>
						<template v-slot:item.avance="{ item }">
							{{ formatearNumero( item.avance ) }} %
						</template>
					</v-data-table>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="dialogAvanceSucursal = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog resumen comparativo de participación (datos persistidos) -->
		<v-dialog v-model="dialogComparativoParticipacion" max-width="1200px" scrollable>
			<v-card>
				<v-card-title class="text-subtitle-1">
					Resumen Comparativo de Participación
					<span v-if="etiquetaComparativoCorto" class="text-caption grey--text ml-2">
						{{ etiquetaComparativoCorto }}
					</span>
					<v-spacer></v-spacer>
					<v-btn icon small @click="dialogComparativoParticipacion = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<div v-if="cargandoComparativo" class="text-center py-8">
						<v-progress-circular indeterminate color="primary" size="48"></v-progress-circular>
						<div class="mt-3 text-body-2 grey--text">Comparando ciclo anterior vs el consultado…</div>
					</div>

					<v-alert
						v-else-if="errorComparativo"
						type="error"
						dense
						text
						class="mb-0"
					>
						{{ errorComparativo }}
						<v-btn text small color="primary" class="ml-2" @click="reintentarComparativo()">
							Reintentar
						</v-btn>
					</v-alert>

					<template v-else-if="comparativoParticipacion">
						<v-row dense class="mb-3">
							<v-col cols="12" md="4">
								<v-card outlined class="pa-3 comparativo-card-ant">
									<div class="text-caption font-weight-bold purple--text text--darken-2 mb-1">
										{{ etiquetaCicloComparativo(comparativoParticipacion.ciclo_anterior) }}
										<span class="font-weight-regular grey--text"> (anterior)</span>
									</div>
									<div v-if="comparativoParticipacion.ciclo_anterior">
										<div>Universo total de alumnos: <b>{{ comparativoParticipacion.ciclo_anterior.resumen.total_alumnos }}</b></div>
										<div>Alumnos que respondieron: <b>{{ comparativoParticipacion.ciclo_anterior.resumen.alumnos_encuestados }}</b></div>
										<div>Alumnos faltantes: <b>{{ comparativoParticipacion.ciclo_anterior.resumen.alumnos_faltantes }}</b></div>
										<div>Participación global: <b>{{ formatearNumero(comparativoParticipacion.ciclo_anterior.resumen.porcentaje_participacion) }}%</b></div>
										<div>Calificación general: <b>{{ formatearNumero(comparativoParticipacion.ciclo_anterior.resumen.promedio_general) }}</b></div>
									</div>
									<div v-else class="text-caption grey--text">Sin ciclo anterior</div>
								</v-card>
							</v-col>
							<v-col cols="12" md="4">
								<v-card outlined class="pa-3 comparativo-card-act">
									<div class="text-caption font-weight-bold green--text text--darken-2 mb-1">
										{{ etiquetaCicloComparativo(comparativoParticipacion.ciclo_actual) }}
										<span class="font-weight-regular grey--text"> (consultado)</span>
									</div>
									<div>
										<div>Universo total de alumnos: <b>{{ comparativoParticipacion.ciclo_actual.resumen.total_alumnos }}</b></div>
										<div>Alumnos que respondieron: <b>{{ comparativoParticipacion.ciclo_actual.resumen.alumnos_encuestados }}</b></div>
										<div>Alumnos faltantes: <b>{{ comparativoParticipacion.ciclo_actual.resumen.alumnos_faltantes }}</b></div>
										<div>Participación global: <b>{{ formatearNumero(comparativoParticipacion.ciclo_actual.resumen.porcentaje_participacion) }}%</b></div>
										<div>Calificación general: <b>{{ formatearNumero(comparativoParticipacion.ciclo_actual.resumen.promedio_general) }}</b></div>
									</div>
								</v-card>
							</v-col>
							<v-col cols="12" md="4">
								<v-card outlined class="pa-3">
									<div class="text-caption font-weight-bold grey--text text--darken-3 mb-1">
										{{ etiquetaVariacionComparativo }}
									</div>
									<div>
										<div>Universo de alumnos:
											<b :class="claseDelta(comparativoParticipacion.variacion.universo)">
												{{ formatoDelta(comparativoParticipacion.variacion.universo) }}
											</b>
										</div>
										<div>Alumnos respondieron:
											<b :class="claseDelta(comparativoParticipacion.variacion.encuestados)">
												{{ formatoDelta(comparativoParticipacion.variacion.encuestados) }}
											</b>
										</div>
										<div>Alumnos faltantes:
											<b :class="claseDelta(-comparativoParticipacion.variacion.faltantes)">
												{{ formatoDelta(comparativoParticipacion.variacion.faltantes) }}
											</b>
										</div>
										<div>Participación:
											<b :class="claseDelta(comparativoParticipacion.variacion.participacion_pp)">
												{{ formatoDelta(comparativoParticipacion.variacion.participacion_pp) }} pp
											</b>
										</div>
										<div>Calificación general:
											<b :class="claseDelta(comparativoParticipacion.variacion.calificacion)">
												{{ formatoDelta(comparativoParticipacion.variacion.calificacion, 2) }}
											</b>
										</div>
									</div>
								</v-card>
							</v-col>
						</v-row>

						<div class="comparativo-tabla-wrap mb-3">
							<table class="comparativo-tabla">
								<thead>
									<tr>
										<th rowspan="2" class="th-plantel">PLANTEL</th>
										<th colspan="3" class="th-grupo-ant">
											{{ etiquetaCicloCorto(comparativoParticipacion.ciclo_anterior) || 'CICLO ANTERIOR' }}
										</th>
										<th colspan="3" class="th-grupo-act">
											{{ etiquetaCicloCorto(comparativoParticipacion.ciclo_actual) || 'CICLO CONSULTADO' }}
										</th>
										<th colspan="2" class="th-grupo-var">VARIACIÓN</th>
									</tr>
									<tr>
										<th class="th-sub-ant">Alumnos</th>
										<th class="th-sub-ant">Resp.</th>
										<th class="th-sub-ant">Avance%</th>
										<th class="th-sub-act">Alumnos</th>
										<th class="th-sub-act">Resp.</th>
										<th class="th-sub-act">Avance%</th>
										<th class="th-sub-var">Resp.</th>
										<th class="th-sub-var">Calif. Δ</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, idx) in filasComparativoParticipacion"
										:key="'cmp-row-' + idx"
										:class="{ 'fila-total': item.esTotal }"
									>
										<td class="td-plantel" :class="{ 'font-weight-bold': item.esTotal }">{{ item.plantel }}</td>
										<td class="td-ant text-right">{{ item.ant_alumnos }}</td>
										<td class="td-ant text-right">{{ item.ant_resp }}</td>
										<td class="td-ant text-right">{{ formatearNumero(item.ant_avance) }}%</td>
										<td class="td-act text-right">{{ item.act_alumnos }}</td>
										<td class="td-act text-right">{{ item.act_resp }}</td>
										<td class="td-act text-right">{{ formatearNumero(item.act_avance) }}%</td>
										<td class="td-var text-right">
											<span :class="['font-weight-medium', claseDelta(item.var_resp)]">
												{{ formatoDelta(item.var_resp) }}
											</span>
										</td>
										<td class="td-var text-right">
											<span v-if="item.var_calif == null" class="grey--text">—</span>
											<span v-else :class="['font-weight-medium', claseDelta(item.var_calif)]">
												{{ item.var_calif > 0 ? '▲' : (item.var_calif < 0 ? '▼' : '') }}
												{{ formatoDelta(item.var_calif, 2) }}
											</span>
										</td>
									</tr>
								</tbody>
							</table>
						</div>

						<div
							v-if="textoResumenComparativo.length"
							class="comparativo-narrativa text-body-2 grey--text text--darken-2"
						>
							<p
								v-for="(linea, idx) in textoResumenComparativo"
								:key="'cmp-n-' + idx"
								class="mb-1"
							>
								{{ linea }}
							</p>
						</div>
					</template>

					<div v-else class="text-center py-6 text-body-2 grey--text">
						Actualiza el reporte para generar el comparativo.
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="dialogComparativoParticipacion = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog calificación global por pregunta (ciclo anterior vs consultado) -->
		<v-dialog v-model="dialogCalificacionGlobalPreguntas" max-width="1100px" scrollable>
			<v-card>
				<v-card-title class="text-subtitle-1">
					Calificación global por pregunta
					<span v-if="etiquetaComparativoPreguntas" class="text-caption grey--text ml-2">
						{{ etiquetaComparativoPreguntas }}
					</span>
					<v-spacer></v-spacer>
					<v-btn
						color="success"
						dark
						small
						class="mr-2"
						:disabled="!calificacionGlobalPorPregunta.length"
						@click="exportarExcelCalificacionGlobalPreguntas()"
					>
						<v-icon small left>mdi-microsoft-excel</v-icon>
						Excel
					</v-btn>
					<v-btn icon small @click="dialogCalificacionGlobalPreguntas = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row dense class="mb-3" v-if="resumenCalificacionGlobalPreguntas">
						<v-col cols="12" md="3">
							<v-card outlined class="pa-3 comparativo-card-ant">
								<div class="text-caption purple--text text--darken-2 font-weight-bold mb-1">
									{{ etiquetaCicloCorto({ ciclo: resumenCalificacionGlobalPreguntas.cicloAnteriorNombre }) || 'Ciclo anterior' }}
								</div>
								<div class="text-caption grey--text">Promedio global</div>
								<div class="text-h6 font-weight-bold">
									{{
										resumenCalificacionGlobalPreguntas.promedioAnterior == null
											? '—'
											: formatearNumero(resumenCalificacionGlobalPreguntas.promedioAnterior)
									}}
								</div>
							</v-card>
						</v-col>
						<v-col cols="12" md="3">
							<v-card outlined class="pa-3 comparativo-card-act">
								<div class="text-caption green--text text--darken-2 font-weight-bold mb-1">
									{{ etiquetaCicloCorto({ ciclo: resumenCalificacionGlobalPreguntas.cicloActualNombre }) || 'Ciclo consultado' }}
								</div>
								<div class="text-caption grey--text">Promedio global</div>
								<div class="text-h6 font-weight-bold" :class="claseSemaforoTexto(resumenCalificacionGlobalPreguntas.promedioGlobal)">
									{{ formatearNumero(resumenCalificacionGlobalPreguntas.promedioGlobal) }}
								</div>
							</v-card>
						</v-col>
						<v-col cols="12" md="3">
							<v-card outlined class="pa-3">
								<div class="text-caption grey--text text--darken-3 font-weight-bold mb-1">Variación</div>
								<div class="text-caption grey--text">Δ promedio</div>
								<div
									class="text-h6 font-weight-bold"
									:class="claseDelta(resumenCalificacionGlobalPreguntas.varPromedio)"
								>
									{{
										resumenCalificacionGlobalPreguntas.varPromedio == null
											? '—'
											: formatoDelta(resumenCalificacionGlobalPreguntas.varPromedio, 2)
									}}
								</div>
							</v-card>
						</v-col>
						<v-col cols="12" md="3">
							<v-card outlined class="pa-3">
								<div class="text-caption grey--text">Preguntas evaluadas</div>
								<div class="text-h6 font-weight-bold">{{ resumenCalificacionGlobalPreguntas.totalPreguntas }}</div>
								<div class="text-caption grey--text mt-1">
									Resp. act.: {{ resumenCalificacionGlobalPreguntas.totalRespuestas }}
								</div>
							</v-card>
						</v-col>
					</v-row>

					<v-data-table
						:headers="headersCalificacionGlobalPreguntas"
						:items="calificacionGlobalPorPregunta"
						class="elevation-0 mb-3"
						dense
						:items-per-page="25"
					>
						<template v-slot:item.promedio_ant="{ item }">
							<span v-if="item.promedio_ant == null" class="grey--text">—</span>
							<span v-else>{{ formatearNumero(item.promedio_ant) }}</span>
						</template>
						<template v-slot:item.promedio="{ item }">
							<span :class="['font-weight-medium', claseSemaforoTexto(item.promedio)]">
								{{ formatearNumero(item.promedio) }}
							</span>
						</template>
						<template v-slot:item.var_promedio="{ item }">
							<span v-if="item.var_promedio == null" class="grey--text">—</span>
							<span v-else :class="['font-weight-medium', claseDelta(item.var_promedio)]">
								{{ item.var_promedio > 0 ? '▲' : (item.var_promedio < 0 ? '▼' : '') }}
								{{ formatoDelta(item.var_promedio, 2) }}
							</span>
						</template>
					</v-data-table>

					<div
						v-if="textoResumenCalificacionGlobal.length"
						class="comparativo-narrativa text-body-2 grey--text text--darken-2"
					>
						<p
							v-for="(linea, idx) in textoResumenCalificacionGlobal"
							:key="'cgp-' + idx"
							class="mb-1"
						>
							{{ linea }}
						</p>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="dialogCalificacionGlobalPreguntas = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog promedio calificación por sucursal (anterior vs consultado) -->
		<v-dialog v-model="dialogPromedioCalificacionSucursal" max-width="1100px" scrollable>
			<v-card>
				<v-card-title class="text-subtitle-1">
					Promedio de calificación por sucursal
					<span v-if="etiquetaComparativoSucursal" class="text-caption grey--text ml-2">
						{{ etiquetaComparativoSucursal }}
					</span>
					<v-spacer></v-spacer>
					<v-btn
						color="success"
						dark
						small
						class="mr-2"
						:disabled="!filasPromedioCalificacionSucursal.length"
						@click="exportarExcelPromedioCalificacionSucursal()"
					>
						<v-icon small left>mdi-microsoft-excel</v-icon>
						Excel
					</v-btn>
					<v-btn icon small @click="dialogPromedioCalificacionSucursal = false">
						<v-icon>mdi-close</v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row dense class="mb-3" v-if="resumenPromedioCalificacionSucursal">
						<v-col cols="12" md="3">
							<v-card outlined class="pa-3 comparativo-card-ant">
								<div class="text-caption purple--text text--darken-2 font-weight-bold mb-1">
									{{ etiquetaCicloCorto({ ciclo: resumenPromedioCalificacionSucursal.cicloAnteriorNombre }) || 'Ciclo anterior' }}
								</div>
								<div class="text-caption grey--text">Promedio instituciones</div>
								<div class="text-h6 font-weight-bold">
									{{
										resumenPromedioCalificacionSucursal.promedioAnterior == null
											? '—'
											: formatearNumero(resumenPromedioCalificacionSucursal.promedioAnterior)
									}}
								</div>
							</v-card>
						</v-col>
						<v-col cols="12" md="3">
							<v-card outlined class="pa-3 comparativo-card-act">
								<div class="text-caption green--text text--darken-2 font-weight-bold mb-1">
									{{ etiquetaCicloCorto({ ciclo: resumenPromedioCalificacionSucursal.cicloActualNombre }) || 'Ciclo consultado' }}
								</div>
								<div class="text-caption grey--text">Promedio instituciones</div>
								<div
									class="text-h6 font-weight-bold"
									:class="claseSemaforoTexto(resumenPromedioCalificacionSucursal.promedioActual)"
								>
									{{ formatearNumero(resumenPromedioCalificacionSucursal.promedioActual) }}
								</div>
							</v-card>
						</v-col>
						<v-col cols="12" md="3">
							<v-card outlined class="pa-3">
								<div class="text-caption grey--text text--darken-3 font-weight-bold mb-1">Variación</div>
								<div class="text-caption grey--text">Δ promedio</div>
								<div
									class="text-h6 font-weight-bold"
									:class="claseDelta(resumenPromedioCalificacionSucursal.varPromedio)"
								>
									{{
										resumenPromedioCalificacionSucursal.varPromedio == null
											? '—'
											: formatoDelta(resumenPromedioCalificacionSucursal.varPromedio, 2)
									}}
								</div>
							</v-card>
						</v-col>
						<v-col cols="12" md="3">
							<v-card outlined class="pa-3">
								<div class="text-caption grey--text">Sucursales</div>
								<div class="text-h6 font-weight-bold">{{ resumenPromedioCalificacionSucursal.totalSucursales }}</div>
								<div class="text-caption grey--text mt-1">
									Alumnos act.: {{ resumenPromedioCalificacionSucursal.totalAlumnos }}
								</div>
							</v-card>
						</v-col>
					</v-row>

					<div class="comparativo-tabla-wrap mb-3">
						<table class="comparativo-tabla tabla-sucursal-calif">
							<thead>
								<tr>
									<th class="th-plantel">#</th>
									<th class="th-plantel">PLANTEL</th>
									<th class="th-grupo-act">{{ etiquetaAlumnosCicloActual }}</th>
									<th class="th-grupo-ant">{{ etiquetaCodigoCicloAnterior || 'C. ant.' }}</th>
									<th class="th-grupo-act">{{ etiquetaCodigoCicloActual || 'C. act.' }}</th>
									<th class="th-grupo-var">Δ</th>
									<th class="th-grupo-var">{{ etiquetaEstatusCicloActual }}</th>
								</tr>
							</thead>
							<tbody>
								<tr
									v-for="item in filasPromedioCalificacionSucursal"
									:key="'suc-calif-' + item.id_plantel"
									:class="'fila-estatus-' + item.estatusKey"
								>
									<td class="text-right">{{ item.num }}º</td>
									<td class="td-plantel font-weight-medium">{{ item.plantel }}</td>
									<td class="td-act text-right">{{ item.alumnos }} alumnos</td>
									<td class="td-ant text-right">
										<span v-if="item.promedio_ant == null" class="grey--text">—</span>
										<span v-else>{{ formatearNumero(item.promedio_ant) }}</span>
									</td>
									<td class="td-act text-right">
										<span :class="claseSemaforoTexto(item.promedio_act)">
											{{ formatearNumero(item.promedio_act) }}
										</span>
									</td>
									<td class="td-var text-right">
										<span v-if="item.var_promedio == null" class="grey--text">—</span>
										<span v-else :class="['font-weight-medium', claseDelta(item.var_promedio)]">
											{{ item.var_promedio > 0 ? '▲' : (item.var_promedio < 0 ? '▼' : '') }}
											{{ formatoDelta(item.var_promedio, 2) }}
										</span>
									</td>
									<td class="td-var text-center">
										<span class="estatus-chip" :class="'estatus-' + item.estatusKey">
											{{ item.estatus }}
										</span>
									</td>
								</tr>
							</tbody>
						</table>
					</div>

					<div
						v-if="textoResumenPromedioSucursal.length"
						class="comparativo-narrativa text-body-2 grey--text text--darken-2"
					>
						<p
							v-for="(linea, idx) in textoResumenPromedioSucursal"
							:key="'suc-n-' + idx"
							class="mb-1"
						>
							{{ linea }}
						</p>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text color="primary" @click="dialogPromedioCalificacionSucursal = false">Cerrar</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<!-- Dialog incidencia alumno sin encuesta -->
		<v-dialog v-model="dialogIncidencia" max-width="560px" persistent scrollable>
			<v-card>
				<v-card-title class="text-subtitle-1">
					{{ incidenciaSoloLectura ? 'Incidencia registrada' : 'Registrar incidencia' }}
					<v-spacer></v-spacer>
					<v-btn icon small @click="cerrarIncidencia()"><v-icon>mdi-close</v-icon></v-btn>
				</v-card-title>
				<v-card-text v-if="alumnoIncidencia">
					<div class="mb-3">
						<div class="font-weight-medium">{{ alumnoIncidencia.alumno }}</div>
						<div class="text-caption">{{ alumnoIncidencia.plantel }} · {{ alumnoIncidencia.grupo }}</div>
					</div>
					<v-textarea
						v-model="formIncidencia.comentario"
						filled
						dense
						hide-details
						label="Motivo / comentario"
						:readonly="incidenciaSoloLectura"
						rows="3"
						class="mb-3"
					></v-textarea>
					<div v-if="!incidenciaSoloLectura">
						<v-file-input
							v-model="formIncidencia.archivo"
							filled
							dense
							hide-details
							accept="image/png, image/jpeg, image/bmp, image/webp"
							prepend-icon="mdi-camera"
							label="Evidencia (1 imagen)"
							@change="previsualizarIncidencia()"
						></v-file-input>
						<v-card v-if="formIncidencia.preview" class="mt-3 pa-2" flat outlined>
							<v-img :src="formIncidencia.preview" contain max-height="220"></v-img>
						</v-card>
					</div>
					<div v-else-if="formIncidencia.evidenciaUrl">
						<div class="text-caption mb-1">Evidencia</div>
						<v-card class="pa-2" flat outlined>
							<v-img :src="formIncidencia.evidenciaUrl" contain max-height="220" @click="dialogImagenIncidencia = true" style="cursor:pointer"></v-img>
						</v-card>
					</div>
				</v-card-text>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn text @click="cerrarIncidencia()">Cerrar</v-btn>
					<v-btn
						v-if="!incidenciaSoloLectura"
						color="success"
						dark
						tile
						small
						:loading="guardandoIncidencia"
						:disabled="!puedeGuardarIncidencia"
						@click="guardarIncidencia()"
					>
						Guardar
					</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogImagenIncidencia" max-width="900px">
			<v-card v-if="formIncidencia.evidenciaUrl">
				<v-img :src="formIncidencia.evidenciaUrl" contain max-height="80vh"></v-img>
			</v-card>
		</v-dialog>

		<!-- Dialog de carga -->
		<Alerta               v-if="respuestaAlerta"             :parametros="parametros"/>
		<carga                v-if="cargar"/>

	</v-container>
</template>

<script>
	import axios from 'axios';
	import { mapGetters } from 'vuex'
	// Componentes
	import Alerta                from '@/components/alertas/Alerta.vue'
	import carga                 from '@/components/alertas/carga.vue';

	import validarErrores       from '@/mixins/validarErrores'
	import XLSX                 from 'xlsx'
	import funcionesExcel       from '@/mixins/funcionesExcel'
	import mixinNominaSabatina  from '@/mixins/mixinNominaSabatina'
	import mixinNominaQuincena  from '@/mixins/mixinNominaQuincena'

	const PUESTOS_SOLO_AVANCE_SATISFACCION = [19, 52]

	export default {
		components:{
			Alerta,
			carga,
		},

		mixins: [ validarErrores, funcionesExcel, mixinNominaSabatina, mixinNominaQuincena ],

		data: () => ({
    	// Alertas
    	parametros:{
        dialogError: false,
        mensaje: '',
        color: ''
      },

	  preguntas: [],
	  nivelSeleccionado: '',
	  categoriaSeleccionada: '',

      respuestaAlerta:false,
      loader: true,
      cargar: false,

      headers1: [
        { text: 'id'                , value: 'id_teacher'           },
        { text: 'Teacher'           , value: 'teacher'              },  
        { text: 'Categoría'         , value: 'aceptado'             },  
        { text: 'HSBC'              , value: 'hsbc'                 },  
        { text: 'Plantel'           , value: 'plantel'              },  
	      { text: 'existeCategoria'   , value: 'existeCategoria'      },  
        { text: 'PAGO_SABADO'       , value: 'PAGO_SABADO', align: 'end'},  
      ],

      headersCategoria: [
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
        { text: 'Respuestas obtenidas', value: 'respuestas'      },
      ],

      headersComentario:[
        { text: 'Plantel'           , value: 'plantel'            },
        { text: 'Nivel'             , value: 'nivel'              },
        { text: 'Alumno'            , value: 'alumno'             },
      	{ text: 'Categoría'         , value: 'categoria'          },  
        { text: 'Pregunta'          , value: 'pregunta'           },
        { text: 'Comentario'        , value: 'comentario'         },  
      ],

      headersAvance: [
      	{ text: 'Plantel'    , value: 'plantel'     },
      	{ text: 'Nivel'      , value: 'nivel'       },
      	{ text: 'Grupo'      , value: 'grupo'       },
      	{ text: 'Alumno'     , value: 'alumno'      },
      	{ text: 'Encuesta'   , value: 'encuestado'  , sortable: false, align: 'center', width: '140px' },
      	{ text: 'Incidencia' , value: 'incidencia'  , sortable: false, align: 'center', width: '160px' },
      ],

      headersFaltantes:[
      	{ text: 'Nombre'         , value: 'alumno'                },
      	{ text: 'Grupo'          , value: 'grupo'                 },
      	{ text: 'Plantel'        , value: 'plantel'               },
      	{ text: 'Sig. ciclo'     , value: 'estatus_siguiente_ciclo', width: '120px', align: 'center', sortable: false },
      ],

      headersAvanceSucursal: [
      	{ text: 'Sucursal'     , value: 'plantel'     },
      	{ text: 'Total'        , value: 'total'       , align: 'end' },
      	{ text: 'Encuestados'  , value: 'encuestados' , align: 'end' },
      	{ text: 'Faltan'       , value: 'faltan'      , align: 'end' },
      	{ text: 'Avance (%)'   , value: 'avance'      , align: 'end' },
      ],

			headersComparativoParticipacion: [
				{ text: 'Plantel', value: 'plantel' },
				{ text: 'Alumnos ant.', value: 'ant_alumnos', align: 'end' },
				{ text: 'Resp. ant.', value: 'ant_resp', align: 'end' },
				{ text: 'Avance ant.', value: 'ant_avance', align: 'end' },
				{ text: 'Alumnos act.', value: 'act_alumnos', align: 'end' },
				{ text: 'Resp. act.', value: 'act_resp', align: 'end' },
				{ text: 'Avance act.', value: 'act_avance', align: 'end' },
				{ text: 'Var. Resp.', value: 'var_resp', align: 'end' },
				{ text: 'Calif. Δ', value: 'var_calif', align: 'end' },
			],

			headersCalificacionGlobalPreguntas: [
				{ text: '#', value: 'num', width: '48px', align: 'end' },
				{ text: 'Categoría', value: 'categoria', width: '130px' },
				{ text: 'Pregunta', value: 'pregunta' },
				{ text: 'Prom. ant.', value: 'promedio_ant', align: 'end', width: '100px' },
				{ text: 'Prom. act.', value: 'promedio', align: 'end', width: '100px' },
				{ text: 'Δ', value: 'var_promedio', align: 'end', width: '90px' },
				{ text: 'Resp. act.', value: 'respuestas', align: 'end', width: '100px' },
			],


			headersJefe: [
        { text: 'Jefe'            , value: 'nombre_completo'     },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
      ],


      headersEscuela: [
        { text: 'Escuela'         , value: 'unidad_negocio'      },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
      ],

      headersDepartamento: [
        { text: 'Plantel'         , value: 'plantel'      },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
        { text: 'Respuestas obtenidas', value: 'respuestas'      },
      ],

      headersNivel: [
        { text: 'Nivel'           , value: 'nivel'      },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
        { text: 'Respuestas obtenidas', value: 'respuestas'      },
      ],

      headersTeachers: [
        { text: 'Teacher'         , value: 'nombre_completo'     },  
        { text: 'Categoría'       , value: 'categoria'           },  
        { text: 'Promedio'        , value: 'promedio'            },  
        { text: 'Respuestas obtenidas', value: 'respuestas'      },
      ],

	  headersPreguntas: [
		{ text: 'Categoría'       , value: 'categoria'	},
		{ text: 'Plantel'       	  , value: 'plantel'	},
		{ text: 'Nivel'       	  , value: 'nivel'		},
		{ text: 'Pregunta'        , value: 'pregunta'	},
        { text: 'Valor'			  , value: 'valor'		}, 
      ],

      search:'',
      data:[],

      tab: 0,
	  ciclos:[],
      ciclo:null,
      faltantes:[],
			avancePorSucursal:[],
			cicloSiguiente: null,
			dialogAvanceSucursal: false,
			dialogComparativoParticipacion: false,
			comparativoParticipacion: null,
			cargandoComparativo: false,
			errorComparativo: '',
			comparativoRequestId: 0,
			ultimoPayloadComparativo: null,
			dialogCalificacionGlobalPreguntas: false,
			preguntasPromedioActualApi: [],
			preguntasPromedioAnteriorApi: [],
			cicloAnteriorPreguntasNombre: '',
			cicloActualPreguntasNombre: '',
			dialogPromedioCalificacionSucursal: false,
			promediosPlantelActualApi: [],
			promediosPlantelAnteriorApi: [],
			alumnosLista:[],
			categorias:[],
			comentarios:[],
			jefe:[],
			escuela:[],
			opEscuela: 1,
			departamentos:[],
			nivel:[],
			teachers:[],
			alumnos:0,
			planteles:[],
			niveles:[],
			filtroPlantel:null,
			filtroNivelReporte:null,
			avanceAlumnos: [],
			dialogIncidencia: false,
			dialogImagenIncidencia: false,
			incidenciaSoloLectura: false,
			alumnoIncidencia: null,
			guardandoIncidencia: false,
			urlEvidencia: '',
			formIncidencia: {
				comentario: '',
				archivo: null,
				preview: '',
				evidenciaUrl: '',
			},
			resumen:{
				promedio_general: 0,
				respuestas_obtenidas: 0,
				alumnos_encuestados: 0,
				total_alumnos: 0,
				porcentaje_participacion: 0,
				peor_categoria: null,
				mejor_categoria: null,
				sucursal_critica: null,
			},
		}),

		computed: {

			...mapGetters( 'login' ,['getdatosUsuarioERPERP']),

			tieneAccesoReporteSatisfaccion () {
				const u = this.getdatosUsuarioERPERP || {}
				const idpuesto = Number( u.idpuesto )
				const idUsuario = Number(
					u.id_usuario != null && u.id_usuario !== ''
						? u.id_usuario
						: u.iderp
				)
				if ( idpuesto === 88 && idUsuario !== 1312 ) return false
				return true
			},

			modoSoloAvance () {
				const idpuesto = Number( this.getdatosUsuarioERPERP && this.getdatosUsuarioERPERP.idpuesto )
				return PUESTOS_SOLO_AVANCE_SATISFACCION.includes( idpuesto )
			},

			promedioGeneralNumero () {
				return Number( this.resumen.promedio_general ) || 0
			},

			promedioGeneralDisplay () {
				return this.formatearNumero( this.promedioGeneralNumero )
			},

			porcentajeParticipacionDisplay () {
				return this.formatearNumero( this.resumen.porcentaje_participacion )
			},

			semaforoPromedioGeneral () {
				return this.semaforoPromedio( this.promedioGeneralNumero )
			},

			peorCategoriaDisplay () {
				return this.resumenConPromedio( this.resumen.peor_categoria, 'categoria' )
			},

			mejorCategoriaDisplay () {
				return this.resumenConPromedio( this.resumen.mejor_categoria, 'categoria' )
			},

			sucursalCriticaDisplay () {
				return this.resumenConPromedio( this.resumen.sucursal_critica, 'plantel' )
			},

			categoriasFiltradas () {
				return [...new Set(this.preguntas.map(p => p.categoria))]
			},

			nivelesFiltradas () {
				return [...new Set(this.preguntas.map(p => p.nivel))]
			},

			preguntasFiltradas () {
				return this.preguntas.filter(p => {
				const coincideCategoria =
					!this.categoriaSeleccionada ||
					p.categoria === this.categoriaSeleccionada

				const coincideNivel =
					!this.nivelSeleccionado ||
					p.nivel === this.nivelSeleccionado

				return coincideCategoria && coincideNivel
				})
			},

			tieneDatosReporte () {
				return [
					this.nivel,
					this.categorias,
					this.departamentos,
					this.teachers,
					this.faltantes,
					this.preguntas,
					this.comentarios,
					this.avanceAlumnos,
				].some( items => Array.isArray( items ) && items.length )
			},

			avanceFaltantes () {
				const total = Number( this.alumnos ) || 0
				const falta = ( this.faltantes && this.faltantes.length ) || 0
				if ( !total ) return '0.00'
				const respondieron = total - falta
				return ( ( respondieron / total ) * 100 ).toFixed( 2 )
			},

			cicloSiguienteCorto () {
				if ( !this.cicloSiguiente ) return ''
				const match = String( this.cicloSiguiente ).match( /(\d{1,2}_\d{2})/ )
				return match ? match[1] : String( this.cicloSiguiente ).replace( /CICLO\s*/i, '' ).trim()
			},

			avanceConteo () {
				const lista = this.avanceAlumnos || []
				const encuestados = lista.filter( a => Number( a.encuestado ) === 1 ).length
				const pendientes = lista.length - encuestados
				const incidencias = lista.filter( a => a.id_incidencia ).length
				return { encuestados, pendientes, incidencias }
			},

			filasComparativoParticipacion () {
				const c = this.comparativoParticipacion
				if ( !c ) return []
				const filas = ( c.filas || [] ).map( ( f ) => ( {
					plantel: f.plantel,
					ant_alumnos: f.anterior.alumnos,
					ant_resp: f.anterior.encuestados,
					ant_avance: f.anterior.avance,
					act_alumnos: f.actual.alumnos,
					act_resp: f.actual.encuestados,
					act_avance: f.actual.avance,
					var_resp: f.var_resp,
					var_calif: f.var_calif,
					esTotal: false,
				} ) )
				if ( c.total ) {
					filas.push( {
						plantel: 'TOTAL INSTITUCIÓN',
						ant_alumnos: c.total.anterior.alumnos,
						ant_resp: c.total.anterior.encuestados,
						ant_avance: c.total.anterior.avance,
						act_alumnos: c.total.actual.alumnos,
						act_resp: c.total.actual.encuestados,
						act_avance: c.total.actual.avance,
						var_resp: c.total.var_resp,
						var_calif: c.total.var_calif,
						esTotal: true,
					} )
				}
				return filas
			},

			etiquetaComparativoCorto () {
				const c = this.comparativoParticipacion
				if ( !c || !c.ciclo_actual ) return ''
				const ant = this.codigoCicloCorto( c.ciclo_anterior && c.ciclo_anterior.ciclo )
				const act = this.codigoCicloCorto( c.ciclo_actual.ciclo )
				if ( ant && act ) return `${ant} → ${act}`
				return act ? `vs ${act}` : ''
			},

			etiquetaVariacionComparativo () {
				const c = this.comparativoParticipacion
				if ( !c || !c.ciclo_actual ) return 'Variación'
				const ant = this.codigoCicloCorto( c.ciclo_anterior && c.ciclo_anterior.ciclo )
				const act = this.codigoCicloCorto( c.ciclo_actual.ciclo )
				if ( ant && act ) {
					const shortA = ant.match( /^(\d{1,2})/ ) ? `C${ant.match( /^(\d{1,2})/ )[1]}` : ant
					const shortB = act.match( /^(\d{1,2})/ ) ? `C${act.match( /^(\d{1,2})/ )[1]}` : act
					return `Variación ${shortA} → ${shortB}`
				}
				return 'Variación'
			},

			textoResumenComparativo () {
				const c = this.comparativoParticipacion
				if ( !c || !c.ciclo_actual ) return []
				const lineas = []
				const pp = Number( c.variacion && c.variacion.participacion_pp ) || 0
				const respAnt = Number( c.ciclo_anterior && c.ciclo_anterior.resumen
					? c.ciclo_anterior.resumen.alumnos_encuestados
					: 0 )
				const respAct = Number( c.ciclo_actual.resumen.alumnos_encuestados ) || 0
				const nombreAnt = c.ciclo_anterior ? c.ciclo_anterior.ciclo : 'ciclo anterior'
				const nombreAct = c.ciclo_actual.ciclo

				if ( !c.ciclo_anterior ) {
					lineas.push( `Solo hay datos del ciclo consultado (${nombreAct}). No se encontró ciclo anterior para comparar.` )
					return lineas
				}

				if ( pp > 0 ) {
					lineas.push(
						`La participación institucional creció ${this.formatoDelta( pp )} pp entre ${nombreAnt} (anterior) y ${nombreAct} (consultado), pasando de ${respAnt} a ${respAct} alumnos encuestados.`
					)
				} else if ( pp < 0 ) {
					lineas.push(
						`La participación institucional bajó ${this.formatoDelta( pp )} pp entre ${nombreAnt} (anterior) y ${nombreAct} (consultado), pasando de ${respAnt} a ${respAct} alumnos encuestados.`
					)
				} else {
					lineas.push(
						`La participación institucional se mantuvo estable (${this.formatearNumero( c.ciclo_actual.resumen.porcentaje_participacion )} %) entre ${nombreAnt} (anterior) y ${nombreAct} (consultado).`
					)
				}

				const filas = ( c.filas || [] ).slice()
				const lider = filas
					.filter( ( f ) => Number( f.var_resp ) > 0 )
					.sort( ( a, b ) => Number( b.var_resp ) - Number( a.var_resp ) )[0]
				if ( lider ) {
					lineas.push(
						`${lider.plantel} lideró el incremento en términos absolutos (${this.formatoDelta( lider.var_resp )} alumnos, de ${this.formatearNumero( lider.anterior.avance )}% a ${this.formatearNumero( lider.actual.avance )}%).`
					)
				}

				const mejoras = filas
					.filter( ( f ) => f.var_calif != null && Number( f.var_calif ) > 0 )
					.sort( ( a, b ) => Number( b.var_calif ) - Number( a.var_calif ) )
					.slice( 0, 4 )
				if ( mejoras.length ) {
					lineas.push(
						`Mejores mejoras de calificación: ${mejoras.map( ( m ) => `${m.plantel} (${this.formatoDelta( m.var_calif, 2 )})` ).join( ', ' )}.`
					)
				}

				const caida = filas
					.filter( ( f ) => f.var_calif != null && Number( f.var_calif ) < 0 )
					.sort( ( a, b ) => Number( a.var_calif ) - Number( b.var_calif ) )[0]
				if ( caida ) {
					const volumen = Number( caida.actual.alumnos ) || 0
					const notaVolumen = volumen >= 200 ? ' (sucursal de alto volumen)' : ''
					lineas.push(
						`Mayor caída de calificación: ${caida.plantel} (${this.formatoDelta( caida.var_calif, 2 )})${notaVolumen}.`
					)
				}

				const califVar = Number( c.variacion && c.variacion.calificacion ) || 0
				if ( califVar > 0 ) {
					lineas.push( `La calificación general subió ${this.formatoDelta( califVar, 2 )} puntos.` )
				} else if ( califVar < 0 ) {
					lineas.push( `La calificación general bajó ${this.formatoDelta( califVar, 2 )} puntos.` )
				}

				return lineas
			},

			tieneCalificacionGlobalPreguntas () {
				return this.calificacionGlobalPorPregunta.length > 0
			},

			cicloSeleccionadoTexto () {
				if ( !this.ciclo ) return ''
				if ( typeof this.ciclo === 'object' && this.ciclo.ciclo ) return String( this.ciclo.ciclo )
				return ''
			},

			etiquetaComparativoPreguntas () {
				const ant = this.codigoCicloCorto( this.cicloAnteriorPreguntasNombre )
				const act = this.codigoCicloCorto( this.cicloActualPreguntasNombre || this.cicloSeleccionadoTexto )
				if ( ant && act ) return `${ant} → ${act}`
				return act || this.cicloSeleccionadoTexto || ''
			},

			promedioPreguntasActualBase () {
				if ( this.preguntasPromedioActualApi && this.preguntasPromedioActualApi.length ) {
					return this.preguntasPromedioActualApi.map( ( row ) => ( {
						pregunta: String( row.pregunta || '' ).trim(),
						categoria: String( row.categoria || 'ACADEMICO' ).trim() || 'ACADEMICO',
						promedio: Number( row.promedio ) || 0,
						respuestas: Number( row.respuestas ) || 0,
					} ) )
				}
				const mapa = new Map()
				;( this.preguntas || [] ).forEach( ( row ) => {
					const categoria = String( row.categoria || '' ).trim()
					if ( /^OPINI/i.test( categoria ) ) return
					const valor = Number( row.valor )
					if ( !Number.isFinite( valor ) ) return
					const pregunta = String( row.pregunta || '' ).trim()
					if ( !pregunta ) return
					const key = pregunta.toLowerCase()
					if ( !mapa.has( key ) ) {
						mapa.set( key, {
							pregunta,
							categoria: categoria || 'ACADEMICO',
							suma: 0,
							respuestas: 0,
						} )
					}
					const item = mapa.get( key )
					item.suma += valor
					item.respuestas += 1
				} )
				return Array.from( mapa.values() ).map( ( item ) => ( {
					pregunta: item.pregunta,
					categoria: item.categoria,
					promedio: item.respuestas ? this.round2Comparativo( item.suma / item.respuestas ) : 0,
					respuestas: item.respuestas,
				} ) )
			},

			calificacionGlobalPorPregunta () {
				const mapAnt = new Map()
				;( this.preguntasPromedioAnteriorApi || [] ).forEach( ( row ) => {
					const pregunta = String( row.pregunta || '' ).trim()
					if ( !pregunta ) return
					mapAnt.set( pregunta.toLowerCase(), {
						pregunta,
						categoria: String( row.categoria || 'ACADEMICO' ).trim() || 'ACADEMICO',
						promedio: Number( row.promedio ) || 0,
						respuestas: Number( row.respuestas ) || 0,
					} )
				} )
				const mapAct = new Map()
				;( this.promedioPreguntasActualBase || [] ).forEach( ( row ) => {
					const pregunta = String( row.pregunta || '' ).trim()
					if ( !pregunta ) return
					mapAct.set( pregunta.toLowerCase(), row )
				} )
				const keys = new Set( [ ...mapAct.keys(), ...mapAnt.keys() ] )
				const filas = []
				keys.forEach( ( key ) => {
					const a = mapAct.get( key )
					const b = mapAnt.get( key )
					const promedioAct = a ? Number( a.promedio ) : null
					const promedioAnt = b ? Number( b.promedio ) : null
					filas.push( {
						pregunta: ( a && a.pregunta ) || ( b && b.pregunta ) || '',
						categoria: ( a && a.categoria ) || ( b && b.categoria ) || 'ACADEMICO',
						promedio_ant: promedioAnt,
						promedio: promedioAct == null ? 0 : promedioAct,
						var_promedio:
							promedioAct != null && promedioAnt != null
								? this.round2Comparativo( promedioAct - promedioAnt )
								: null,
						respuestas: a ? Number( a.respuestas ) || 0 : 0,
					} )
				} )
				return filas
					.sort( ( x, y ) => {
						const cat = String( x.categoria ).localeCompare( String( y.categoria ), 'es' )
						if ( cat !== 0 ) return cat
						return String( x.pregunta ).localeCompare( String( y.pregunta ), 'es' )
					} )
					.map( ( item, idx ) => ( { ...item, num: idx + 1 } ) )
			},

			resumenCalificacionGlobalPreguntas () {
				const filas = this.calificacionGlobalPorPregunta
				if ( !filas.length ) return null
				const conActual = filas.filter( ( f ) => Number( f.respuestas ) > 0 )
				const totalRespuestas = conActual.reduce( ( s, f ) => s + ( Number( f.respuestas ) || 0 ), 0 )
				const sumaPonderada = conActual.reduce(
					( s, f ) => s + ( Number( f.promedio ) || 0 ) * ( Number( f.respuestas ) || 0 ),
					0
				)
				const promedioGlobal = totalRespuestas
					? this.round2Comparativo( sumaPonderada / totalRespuestas )
					: 0

				const antRows = this.preguntasPromedioAnteriorApi || []
				const totalRespAnt = antRows.reduce( ( s, f ) => s + ( Number( f.respuestas ) || 0 ), 0 )
				const sumaAnt = antRows.reduce(
					( s, f ) => s + ( Number( f.promedio ) || 0 ) * ( Number( f.respuestas ) || 0 ),
					0
				)
				const promedioAnterior = totalRespAnt
					? this.round2Comparativo( sumaAnt / totalRespAnt )
					: null

				return {
					totalPreguntas: filas.length,
					totalRespuestas,
					promedioGlobal,
					promedioAnterior,
					varPromedio:
						promedioAnterior == null
							? null
							: this.round2Comparativo( promedioGlobal - promedioAnterior ),
					cicloAnteriorNombre: this.cicloAnteriorPreguntasNombre || '',
					cicloActualNombre: this.cicloActualPreguntasNombre || this.cicloSeleccionadoTexto || '',
				}
			},

			textoResumenCalificacionGlobal () {
				const filas = this.calificacionGlobalPorPregunta
				if ( !filas.length ) return []
				const lineas = []
				const resumen = this.resumenCalificacionGlobalPreguntas
				const nombreAnt = resumen.cicloAnteriorNombre || 'ciclo anterior'
				const nombreAct = resumen.cicloActualNombre || 'ciclo consultado'

				if ( resumen.promedioAnterior == null ) {
					lineas.push(
						`Promedio global del ciclo consultado (${nombreAct}): ${this.formatearNumero( resumen.promedioGlobal )} en ${resumen.totalPreguntas} preguntas. No hay ciclo anterior para comparar.`
					)
				} else {
					const delta = resumen.varPromedio
					if ( delta > 0 ) {
						lineas.push(
							`La calificación global subió ${this.formatoDelta( delta, 2 )} puntos entre ${nombreAnt} (${this.formatearNumero( resumen.promedioAnterior )}) y ${nombreAct} (${this.formatearNumero( resumen.promedioGlobal )}).`
						)
					} else if ( delta < 0 ) {
						lineas.push(
							`La calificación global bajó ${this.formatoDelta( delta, 2 )} puntos entre ${nombreAnt} (${this.formatearNumero( resumen.promedioAnterior )}) y ${nombreAct} (${this.formatearNumero( resumen.promedioGlobal )}).`
						)
					} else {
						lineas.push(
							`La calificación global se mantuvo estable en ${this.formatearNumero( resumen.promedioGlobal )} entre ${nombreAnt} y ${nombreAct}.`
						)
					}
				}

				const conDelta = filas.filter( ( f ) => f.var_promedio != null )
				const mejoras = conDelta.filter( ( f ) => f.var_promedio > 0 ).sort( ( a, b ) => b.var_promedio - a.var_promedio ).slice( 0, 3 )
				const caidas = conDelta.filter( ( f ) => f.var_promedio < 0 ).sort( ( a, b ) => a.var_promedio - b.var_promedio ).slice( 0, 3 )
				if ( mejoras.length ) {
					lineas.push(
						`Mayores mejoras por pregunta: ${mejoras.map( ( m ) => `${m.pregunta} (${this.formatoDelta( m.var_promedio, 2 )}, de ${this.formatearNumero( m.promedio_ant )} a ${this.formatearNumero( m.promedio )})` ).join( '; ' )}.`
					)
				}
				if ( caidas.length ) {
					lineas.push(
						`Mayores caídas por pregunta: ${caidas.map( ( m ) => `${m.pregunta} (${this.formatoDelta( m.var_promedio, 2 )}, de ${this.formatearNumero( m.promedio_ant )} a ${this.formatearNumero( m.promedio )})` ).join( '; ' )}.`
					)
				}
				return lineas
			},

			tienePromedioCalificacionSucursal () {
				return this.filasPromedioCalificacionSucursal.length > 0
			},

			etiquetaComparativoSucursal () {
				return this.etiquetaComparativoPreguntas
			},

			etiquetaCodigoCicloAnterior () {
				const c = this.codigoCicloCorto( this.cicloAnteriorPreguntasNombre )
				return c ? `C${c}` : ''
			},

			etiquetaCodigoCicloActual () {
				const c = this.codigoCicloCorto( this.cicloActualPreguntasNombre || this.cicloSeleccionadoTexto )
				return c ? `C${c}` : ''
			},

			etiquetaAlumnosCicloActual () {
				const c = this.codigoCicloCorto( this.cicloActualPreguntasNombre || this.cicloSeleccionadoTexto )
				const mes = c && c.match( /^(\d{1,2})/ ) ? c.match( /^(\d{1,2})/ )[1] : ''
				return mes ? `ALUMNOS C${mes}` : 'ALUMNOS'
			},

			etiquetaEstatusCicloActual () {
				const c = this.codigoCicloCorto( this.cicloActualPreguntasNombre || this.cicloSeleccionadoTexto )
				const mes = c && c.match( /^(\d{1,2})/ ) ? c.match( /^(\d{1,2})/ )[1] : ''
				return mes ? `ESTATUS C${mes}` : 'ESTATUS'
			},

			filasPromedioCalificacionSucursal () {
				const mapAlumnos = new Map()
				;( this.avancePorSucursal || [] ).forEach( ( row ) => {
					mapAlumnos.set( Number( row.id_plantel ), {
						plantel: row.plantel,
						alumnos: Number( row.encuestados ) || 0,
						total: Number( row.total ) || 0,
					} )
				} )

				const mapAct = new Map()
				;( this.promediosPlantelActualApi || [] ).forEach( ( row ) => {
					const id = Number( row.id_plantel )
					if ( !Number.isFinite( id ) ) return
					mapAct.set( id, {
						id_plantel: id,
						plantel: row.plantel,
						promedio: Number( row.promedio ) || 0,
					} )
				} )
				// Fallback: si API aún no trae promedios, no armar filas vacías falsas
				if ( !mapAct.size ) return []

				const mapAnt = new Map()
				;( this.promediosPlantelAnteriorApi || [] ).forEach( ( row ) => {
					const id = Number( row.id_plantel )
					if ( !Number.isFinite( id ) ) return
					mapAnt.set( id, Number( row.promedio ) )
				} )

				const ids = new Set( [ ...mapAct.keys(), ...mapAnt.keys(), ...mapAlumnos.keys() ] )
				const filas = []
				ids.forEach( ( id ) => {
					const act = mapAct.get( id )
					if ( !act ) return
					const ant = mapAnt.has( id ) ? Number( mapAnt.get( id ) ) : null
					const alum = mapAlumnos.get( id )
					const promedioAct = Number( act.promedio )
					const estatus = this.estatusCalificacionSucursal( promedioAct )
					filas.push( {
						id_plantel: id,
						plantel: ( act && act.plantel ) || ( alum && alum.plantel ) || '',
						alumnos: alum ? alum.alumnos : 0,
						promedio_ant: ant != null && Number.isFinite( ant ) ? ant : null,
						promedio_act: promedioAct,
						var_promedio:
							ant != null && Number.isFinite( ant )
								? this.round2Comparativo( promedioAct - ant )
								: null,
						estatus: estatus.label,
						estatusKey: estatus.key,
					} )
				} )

				return filas
					.sort( ( a, b ) => ( Number( a.promedio_act ) || 0 ) - ( Number( b.promedio_act ) || 0 ) )
					.map( ( item, idx ) => ( { ...item, num: idx + 1 } ) )
			},

			resumenPromedioCalificacionSucursal () {
				const filas = this.filasPromedioCalificacionSucursal
				if ( !filas.length ) return null
				const totalAlumnos = filas.reduce( ( s, f ) => s + ( Number( f.alumnos ) || 0 ), 0 )
				const sumaAct = filas.reduce(
					( s, f ) => s + ( Number( f.promedio_act ) || 0 ) * ( Number( f.alumnos ) || 0 ),
					0
				)
				const promedioActual = totalAlumnos
					? this.round2Comparativo( sumaAct / totalAlumnos )
					: this.round2Comparativo(
						filas.reduce( ( s, f ) => s + ( Number( f.promedio_act ) || 0 ), 0 ) / filas.length
					)

				const conAnt = filas.filter( ( f ) => f.promedio_ant != null )
				let promedioAnterior = null
				if ( conAnt.length ) {
					const alumAntProxy = conAnt.reduce( ( s, f ) => s + ( Number( f.alumnos ) || 0 ), 0 )
					if ( alumAntProxy > 0 ) {
						promedioAnterior = this.round2Comparativo(
							conAnt.reduce(
								( s, f ) => s + ( Number( f.promedio_ant ) || 0 ) * ( Number( f.alumnos ) || 0 ),
								0
							) / alumAntProxy
						)
					} else {
						promedioAnterior = this.round2Comparativo(
							conAnt.reduce( ( s, f ) => s + ( Number( f.promedio_ant ) || 0 ), 0 ) / conAnt.length
						)
					}
				}

				return {
					totalSucursales: filas.length,
					totalAlumnos,
					promedioActual,
					promedioAnterior,
					varPromedio:
						promedioAnterior == null
							? null
							: this.round2Comparativo( promedioActual - promedioAnterior ),
					cicloAnteriorNombre: this.cicloAnteriorPreguntasNombre || '',
					cicloActualNombre: this.cicloActualPreguntasNombre || this.cicloSeleccionadoTexto || '',
				}
			},

			textoResumenPromedioSucursal () {
				const filas = this.filasPromedioCalificacionSucursal
				if ( !filas.length ) return []
				const lineas = []
				const r = this.resumenPromedioCalificacionSucursal
				const nombreAnt = r.cicloAnteriorNombre || 'ciclo anterior'
				const nombreAct = r.cicloActualNombre || 'ciclo consultado'

				if ( r.promedioAnterior == null ) {
					lineas.push(
						`Promedio institucional del ciclo consultado (${nombreAct}): ${this.formatearNumero( r.promedioActual )} en ${r.totalSucursales} sucursales. Sin ciclo anterior para comparar.`
					)
				} else if ( r.varPromedio > 0 ) {
					lineas.push(
						`El promedio por sucursal subió ${this.formatoDelta( r.varPromedio, 2 )} entre ${nombreAnt} (${this.formatearNumero( r.promedioAnterior )}) y ${nombreAct} (${this.formatearNumero( r.promedioActual )}).`
					)
				} else if ( r.varPromedio < 0 ) {
					lineas.push(
						`El promedio por sucursal bajó ${this.formatoDelta( r.varPromedio, 2 )} entre ${nombreAnt} (${this.formatearNumero( r.promedioAnterior )}) y ${nombreAct} (${this.formatearNumero( r.promedioActual )}).`
					)
				} else {
					lineas.push(
						`El promedio por sucursal se mantuvo en ${this.formatearNumero( r.promedioActual )} entre ${nombreAnt} y ${nombreAct}.`
					)
				}

				const peores = filas.slice( 0, 3 )
				const mejores = filas.slice().reverse().slice( 0, 3 )
				const mejoras = filas.filter( ( f ) => f.var_promedio != null && f.var_promedio > 0 )
					.sort( ( a, b ) => b.var_promedio - a.var_promedio )
					.slice( 0, 3 )
				const caidas = filas.filter( ( f ) => f.var_promedio != null && f.var_promedio < 0 )
					.sort( ( a, b ) => a.var_promedio - b.var_promedio )
					.slice( 0, 3 )

				if ( peores.length ) {
					lineas.push(
						`Sucursales más bajas (${nombreAct}): ${peores.map( ( p ) => `${p.plantel} (${this.formatearNumero( p.promedio_act )}, ${p.estatus})` ).join( '; ' )}.`
					)
				}
				if ( mejores.length ) {
					lineas.push(
						`Sucursales más altas (${nombreAct}): ${mejores.map( ( p ) => `${p.plantel} (${this.formatearNumero( p.promedio_act )}, ${p.estatus})` ).join( '; ' )}.`
					)
				}
				if ( mejoras.length ) {
					lineas.push(
						`Mayores mejoras: ${mejoras.map( ( m ) => `${m.plantel} (${this.formatoDelta( m.var_promedio, 2 )})` ).join( ', ' )}.`
					)
				}
				if ( caidas.length ) {
					lineas.push(
						`Mayores caídas: ${caidas.map( ( m ) => `${m.plantel} (${this.formatoDelta( m.var_promedio, 2 )})` ).join( ', ' )}.`
					)
				}
				return lineas
			},

			puedeGuardarIncidencia () {
				return !!(
					this.formIncidencia.comentario
					&& this.formIncidencia.comentario.trim()
					&& this.formIncidencia.archivo
					&& !this.guardandoIncidencia
				)
			},

			headersAvanceExcel () {
				return [
					{ text: 'Plantel', value: 'plantel' },
					{ text: 'Nivel', value: 'nivel' },
					{ text: 'Grupo', value: 'grupo' },
					{ text: 'Alumno', value: 'alumno' },
					{ text: 'Encuesta', value: 'encuesta_texto' },
					{ text: 'Incidencia', value: 'incidencia_texto' },
				]
			},

			avanceAlumnosExcel () {
				return ( this.avanceAlumnos || [] ).map( row => ( {
					...row,
					encuesta_texto: Number( row.encuestado ) === 1 ? 'Contestó' : 'Pendiente',
					incidencia_texto: row.id_incidencia ? ( row.incidencia_comentario || 'Registrada' ) : '',
				} ) )
			},

		},

		watch: {
			ciclo( value ){

				if( !this.tieneAccesoReporteSatisfaccion ) return
				if( value && this.opEscuela ){ this.initialize() }

			},


			opEscuela( value ){

				if( !this.tieneAccesoReporteSatisfaccion ) return
				if( value && this.ciclo ){ this.initialize() }

			},

			filtroPlantel () {
				if( !this.tieneAccesoReporteSatisfaccion ) return
				if( this.ciclo ){ this.initialize() }
			},

			filtroNivelReporte () {
				if( !this.tieneAccesoReporteSatisfaccion ) return
				if( this.ciclo ){ this.initialize() }
			}
		},

		async created () {
			if ( !this.tieneAccesoReporteSatisfaccion ) return
			this.urlEvidencia = axios.defaults.baseURL + 'evidencia-tickets/'
    	await this.getCiclos()
		},

		methods:{

			etiquetaEstatusSiguienteCiclo ( item ) {
				if ( item.en_siguiente_ciclo ) {
					return this.cicloSiguienteCorto || 'Sí'
				}
				return 'No'
			},

			formatearNumero ( valor ) {
				const numero = Number( valor )
				if ( !Number.isFinite( numero ) ) return '0.00'
				return numero.toFixed( 2 )
			},

			formatoDelta ( valor, decimales = 0 ) {
				const n = Number( valor )
				if ( !Number.isFinite( n ) ) return '0'
				const abs = decimales > 0 ? Math.abs( n ).toFixed( decimales ) : String( Math.abs( Math.round( n ) ) )
				if ( n > 0 ) return `+${abs}`
				if ( n < 0 ) return `-${abs}`
				return decimales > 0 ? (0).toFixed( decimales ) : '0'
			},

			claseDelta ( valor ) {
				const n = Number( valor )
				if ( !Number.isFinite( n ) || n === 0 ) return ''
				return n > 0 ? 'green--text text--darken-2' : 'red--text text--darken-2'
			},

			claseSemaforoTexto ( valor ) {
				const promedio = Number( valor )
				if ( !Number.isFinite( promedio ) || promedio <= 0 ) return 'grey--text'
				if ( promedio < 8 ) return 'red--text text--darken-2'
				if ( promedio < 9 ) return 'amber--text text--darken-3'
				return 'green--text text--darken-2'
			},

			etiquetaCicloComparativo ( bloque ) {
				if ( !bloque || !bloque.ciclo ) return 'Sin ciclo'
				const corto = this.codigoCicloCorto( bloque.ciclo )
				return corto ? `Ciclo ${corto}` : String( bloque.ciclo )
			},

			etiquetaCicloCorto ( bloque ) {
				if ( !bloque ) return ''
				const texto = typeof bloque === 'string' ? bloque : ( bloque.ciclo || '' )
				const corto = this.codigoCicloCorto( texto )
				return corto ? `CICLO ${corto}` : ( texto || '' )
			},

			codigoCicloCorto ( ciclo ) {
				const texto = String( ciclo || '' )
				const match = texto.match( /(\d{1,2}_\d{2})/ )
				return match ? match[1] : ''
			},

			payloadComparativoActual () {
				const idCiclo = this.idCicloEncuestaSeleccionado()
				if ( idCiclo == null ) return null
				return {
					id_ciclo: idCiclo,
					iderp: this.getdatosUsuarioERPERP.iderp,
					idpuesto: this.getdatosUsuarioERPERP.idpuesto,
					planteles: this.getdatosUsuarioERPERP.planteles,
					op_escuela: this.opEscuela,
					id_plantel: this.filtroPlantel || null,
					id_nivel: this.filtroNivelReporte || null,
				}
			},

			abrirComparativoParticipacion () {
				this.dialogComparativoParticipacion = true
				if ( this.comparativoParticipacion || this.cargandoComparativo ) return
				const payload = this.ultimoPayloadComparativo || this.payloadComparativoActual()
				if ( !payload ) {
					this.errorComparativo = 'Selecciona un ciclo y da Actualizar para cargar el comparativo.'
					return
				}
				this.cargarComparativoParticipacion( payload )
			},

			abrirCalificacionGlobalPreguntas () {
				if ( !this.tieneCalificacionGlobalPreguntas ) {
					this.validarErrorDirecto( 'Primero actualiza el reporte para ver la calificación por pregunta.' )
					return
				}
				this.dialogCalificacionGlobalPreguntas = true
			},

			abrirPromedioCalificacionSucursal () {
				if ( !this.tienePromedioCalificacionSucursal ) {
					this.validarErrorDirecto( 'Espera a que cargue el comparativo o actualiza el reporte.' )
					return
				}
				this.dialogPromedioCalificacionSucursal = true
			},

			estatusCalificacionSucursal ( promedio ) {
				const p = Number( promedio )
				if ( !Number.isFinite( p ) || p <= 0 ) {
					return { key: 'sin', label: 'SIN DATOS' }
				}
				if ( p < 8 ) return { key: 'urgente', label: 'URGENTE' }
				if ( p < 8.35 ) return { key: 'critico', label: 'CRÍTICO' }
				if ( p < 8.55 ) return { key: 'observacion', label: 'OBSERVACIÓN' }
				if ( p < 8.95 ) return { key: 'estable', label: 'ESTABLE' }
				return { key: 'excelente', label: 'EXCELENTE' }
			},

			exportarExcelCalificacionGlobalPreguntas () {
				if ( !this.calificacionGlobalPorPregunta.length ) {
					this.validarErrorDirecto( 'No hay datos de preguntas para exportar.' )
					return
				}
				const workbook = XLSX.utils.book_new()
				const datos = this.mapearDatosExcel( this.headersCalificacionGlobalPreguntas, this.calificacionGlobalPorPregunta )
				const headers = this.headersCalificacionGlobalPreguntas.map( header => header.text )
				const sheet = XLSX.utils.json_to_sheet( datos, { header: headers } )
				XLSX.utils.book_append_sheet( workbook, sheet, 'Calif por pregunta' )
				const ciclo = this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : 'sin_ciclo'
				const escuela = this.opEscuela === 2 ? 'FAST' : 'INBI'
				const nombreArchivo = `calificacion_global_pregunta_${escuela}_${ciclo}`.replace( /[\\/:*?"<>|]/g, '_' )
				XLSX.writeFile( workbook, `${nombreArchivo}.xls` )
			},

			exportarExcelPromedioCalificacionSucursal () {
				if ( !this.filasPromedioCalificacionSucursal.length ) {
					this.validarErrorDirecto( 'No hay datos de sucursales para exportar.' )
					return
				}
				const headers = [
					{ text: '#', value: 'num' },
					{ text: 'Plantel', value: 'plantel' },
					{ text: 'Alumnos', value: 'alumnos' },
					{ text: 'Prom. ant.', value: 'promedio_ant' },
					{ text: 'Prom. act.', value: 'promedio_act' },
					{ text: 'Δ', value: 'var_promedio' },
					{ text: 'Estatus', value: 'estatus' },
				]
				const workbook = XLSX.utils.book_new()
				const datos = this.mapearDatosExcel( headers, this.filasPromedioCalificacionSucursal )
				const sheet = XLSX.utils.json_to_sheet( datos, { header: headers.map( h => h.text ) } )
				XLSX.utils.book_append_sheet( workbook, sheet, 'Promedio sucursal' )
				const ciclo = this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : 'sin_ciclo'
				const escuela = this.opEscuela === 2 ? 'FAST' : 'INBI'
				const nombreArchivo = `promedio_calificacion_sucursal_${escuela}_${ciclo}`.replace( /[\\/:*?"<>|]/g, '_' )
				XLSX.writeFile( workbook, `${nombreArchivo}.xls` )
			},

			reintentarComparativo () {
				const payload = this.ultimoPayloadComparativo || this.payloadComparativoActual()
				if ( !payload ) {
					this.errorComparativo = 'Selecciona un ciclo y da Actualizar.'
					return
				}
				this.cargarComparativoParticipacion( payload )
			},

			round2Comparativo ( n ) {
				const x = Number( n )
				if ( !Number.isFinite( x ) ) return 0
				return Math.round( x * 100 ) / 100
			},

			/** Snapshot del ciclo consultado con lo ya cargado en Actualizar (no reconsulta). */
			snapshotActualDesdeVista ( metaCiclo ) {
				const idCiclo = Number( metaCiclo && metaCiclo.id_ciclo )
				const mapCalif = new Map()
				;( metaCiclo && metaCiclo.promediosPorPlantel ? metaCiclo.promediosPorPlantel : [] ).forEach( ( row ) => {
					mapCalif.set( Number( row.id_plantel ), Number( row.promedio ) || 0 )
				} )
				const avance = ( this.avancePorSucursal || [] ).map( ( row ) => ( {
					...row,
					calificacion: mapCalif.has( Number( row.id_plantel ) )
						? mapCalif.get( Number( row.id_plantel ) )
						: ( row.calificacion != null ? Number( row.calificacion ) : null ),
				} ) )
				const totalAlumnos = Number( this.resumen.total_alumnos ) || avance.reduce( ( s, r ) => s + ( Number( r.total ) || 0 ), 0 )
				const alumnosEncuestados = Number( this.resumen.alumnos_encuestados )
					|| avance.reduce( ( s, r ) => s + ( Number( r.encuestados ) || 0 ), 0 )
				return {
					id_ciclo: idCiclo,
					ciclo: ( metaCiclo && metaCiclo.ciclo ) || String( idCiclo ),
					avancePorSucursal: avance,
					resumen: {
						promedio_general: Number( this.resumen.promedio_general ) || 0,
						respuestas_obtenidas: Number( this.resumen.respuestas_obtenidas ) || 0,
						alumnos_encuestados: alumnosEncuestados,
						total_alumnos: totalAlumnos,
						porcentaje_participacion: Number( this.resumen.porcentaje_participacion ) || 0,
					},
				}
			},

			armarComparativoParticipacion ( actual, anterior ) {
				if ( !actual ) return null
				const mapAnt = new Map()
				;( anterior && anterior.avancePorSucursal ? anterior.avancePorSucursal : [] ).forEach( ( row ) => {
					mapAnt.set( Number( row.id_plantel ), row )
				} )
				const mapAct = new Map()
				;( actual.avancePorSucursal || [] ).forEach( ( row ) => {
					mapAct.set( Number( row.id_plantel ), row )
				} )
				const ids = new Set( [ ...mapAct.keys(), ...mapAnt.keys() ] )
				const filas = []
				ids.forEach( ( idPlantel ) => {
					if ( !Number.isFinite( idPlantel ) ) return
					const a = mapAct.get( idPlantel )
					const b = mapAnt.get( idPlantel )
					const plantel = ( a && a.plantel ) || ( b && b.plantel ) || ''
					const alumnosA = a ? Number( a.total ) || 0 : 0
					const respA = a ? Number( a.encuestados ) || 0 : 0
					const avanceA = a ? Number( a.avance ) || 0 : 0
					const califA = a && a.calificacion != null ? Number( a.calificacion ) : null
					const alumnosB = b ? Number( b.total ) || 0 : 0
					const respB = b ? Number( b.encuestados ) || 0 : 0
					const avanceB = b ? Number( b.avance ) || 0 : 0
					const califB = b && b.calificacion != null ? Number( b.calificacion ) : null
					filas.push( {
						id_plantel: idPlantel,
						plantel,
						anterior: { alumnos: alumnosB, encuestados: respB, avance: avanceB, calificacion: califB },
						actual: { alumnos: alumnosA, encuestados: respA, avance: avanceA, calificacion: califA },
						var_resp: respA - respB,
						var_avance_pp: this.round2Comparativo( avanceA - avanceB ),
						var_calif: califA != null && califB != null ? this.round2Comparativo( califA - califB ) : null,
					} )
				} )
				filas.sort( ( x, y ) => String( x.plantel ).localeCompare( String( y.plantel ), 'es' ) )

				const ra = actual.resumen || {}
				const rb = ( anterior && anterior.resumen ) || {
					total_alumnos: 0,
					alumnos_encuestados: 0,
					porcentaje_participacion: 0,
					promedio_general: 0,
				}
				const faltanA = Math.max( ( Number( ra.total_alumnos ) || 0 ) - ( Number( ra.alumnos_encuestados ) || 0 ), 0 )
				const faltanB = Math.max( ( Number( rb.total_alumnos ) || 0 ) - ( Number( rb.alumnos_encuestados ) || 0 ), 0 )
				const variacion = {
					universo: ( Number( ra.total_alumnos ) || 0 ) - ( Number( rb.total_alumnos ) || 0 ),
					encuestados: ( Number( ra.alumnos_encuestados ) || 0 ) - ( Number( rb.alumnos_encuestados ) || 0 ),
					faltantes: faltanA - faltanB,
					participacion_pp: this.round2Comparativo(
						( Number( ra.porcentaje_participacion ) || 0 ) - ( Number( rb.porcentaje_participacion ) || 0 )
					),
					calificacion: this.round2Comparativo(
						( Number( ra.promedio_general ) || 0 ) - ( Number( rb.promedio_general ) || 0 )
					),
				}
				return {
					ciclo_anterior: anterior
						? {
							id_ciclo: anterior.id_ciclo,
							ciclo: anterior.ciclo,
							resumen: { ...rb, alumnos_faltantes: faltanB },
						}
						: null,
					ciclo_actual: {
						id_ciclo: actual.id_ciclo,
						ciclo: actual.ciclo,
						resumen: { ...ra, alumnos_faltantes: faltanA },
					},
					variacion,
					filas,
					total: {
						anterior: {
							alumnos: Number( rb.total_alumnos ) || 0,
							encuestados: Number( rb.alumnos_encuestados ) || 0,
							avance: Number( rb.porcentaje_participacion ) || 0,
							calificacion: Number( rb.promedio_general ) || 0,
						},
						actual: {
							alumnos: Number( ra.total_alumnos ) || 0,
							encuestados: Number( ra.alumnos_encuestados ) || 0,
							avance: Number( ra.porcentaje_participacion ) || 0,
							calificacion: Number( ra.promedio_general ) || 0,
						},
						var_resp: variacion.encuestados,
						var_avance_pp: variacion.participacion_pp,
						var_calif: variacion.calificacion,
					},
				}
			},

			cargarComparativoParticipacion ( payload ) {
				if ( !this.avancePorSucursal || !this.avancePorSucursal.length ) {
					this.comparativoParticipacion = null
					this.cargandoComparativo = false
					this.errorComparativo = 'Primero actualiza el reporte (necesita avance por sucursal).'
					return
				}
				const requestId = this.comparativoRequestId + 1
				this.comparativoRequestId = requestId
				this.ultimoPayloadComparativo = payload
				this.cargandoComparativo = true
				this.errorComparativo = ''
				this.comparativoParticipacion = null

				this.$http.post( 'encuestas.satisfaccion.comparativo', payload, { timeout: 30000 } ).then( ( response ) => {
					if ( requestId !== this.comparativoRequestId ) return
					const d = response.data || {}
					// Compat: API nueva (ciclo_actual/anterior) o vieja (comparativoParticipacion)
					if ( d.comparativoParticipacion ) {
						this.comparativoParticipacion = d.comparativoParticipacion
					} else {
						const snapshotActual = this.snapshotActualDesdeVista( d.ciclo_actual || { id_ciclo: payload.id_ciclo } )
						const snapshotAnterior = d.ciclo_anterior || null
						this.comparativoParticipacion = this.armarComparativoParticipacion( snapshotActual, snapshotAnterior )
					}
					this.preguntasPromedioActualApi = Array.isArray( d.preguntas_actual ) ? d.preguntas_actual : []
					this.preguntasPromedioAnteriorApi = Array.isArray( d.preguntas_anterior ) ? d.preguntas_anterior : []
					this.cicloActualPreguntasNombre = ( d.ciclo_actual && d.ciclo_actual.ciclo )
						? d.ciclo_actual.ciclo
						: ( this.cicloSeleccionadoTexto || '' )
					this.cicloAnteriorPreguntasNombre = ( d.ciclo_anterior_meta && d.ciclo_anterior_meta.ciclo )
						? d.ciclo_anterior_meta.ciclo
						: ( d.ciclo_anterior && d.ciclo_anterior.ciclo ? d.ciclo_anterior.ciclo : '' )
					this.promediosPlantelActualApi = Array.isArray( d.ciclo_actual && d.ciclo_actual.promediosPorPlantel )
						? d.ciclo_actual.promediosPorPlantel
						: []
					this.promediosPlantelAnteriorApi = ( d.ciclo_anterior && Array.isArray( d.ciclo_anterior.avancePorSucursal ) )
						? d.ciclo_anterior.avancePorSucursal.map( ( row ) => ( {
							id_plantel: row.id_plantel,
							plantel: row.plantel,
							promedio: row.calificacion != null ? Number( row.calificacion ) : null,
						} ) ).filter( ( row ) => row.promedio != null && Number.isFinite( row.promedio ) )
						: []
					if ( !this.comparativoParticipacion ) {
						this.errorComparativo = 'No se pudo armar el comparativo para este ciclo.'
					}
				} ).catch( ( error ) => {
					if ( requestId !== this.comparativoRequestId ) return
					this.comparativoParticipacion = null
					this.preguntasPromedioActualApi = []
					this.preguntasPromedioAnteriorApi = []
					this.promediosPlantelActualApi = []
					this.promediosPlantelAnteriorApi = []
					this.cicloAnteriorPreguntasNombre = ''
					this.cicloActualPreguntasNombre = ''
					const aborted = error.code === 'ECONNABORTED'
						|| ( error.message && String( error.message ).toLowerCase().indexOf( 'timeout' ) >= 0 )
					const msg = aborted
						? 'El comparativo tardó demasiado. Reintenta.'
						: ( ( error.response && error.response.data && error.response.data.message )
							|| error.message
							|| 'Error al cargar el comparativo' )
					this.errorComparativo = msg
					console.error( '[comparativoParticipacion]', error )
				} ).finally( () => {
					if ( requestId !== this.comparativoRequestId ) return
					this.cargandoComparativo = false
				} )
			},

			semaforoPromedio ( valor ) {
				const promedio = Number( valor )
				if ( !Number.isFinite( promedio ) || promedio <= 0 ) {
					return { color: 'grey', background: 'grey lighten-4', label: 'Sin datos' }
				}
				if ( promedio < 8 ) return { color: 'red', background: 'red lighten-5', label: 'Rojo' }
				if ( promedio < 9 ) return { color: 'amber darken-2', background: 'amber lighten-5', label: 'Amarillo' }
				return { color: 'green', background: 'green lighten-5', label: 'Verde' }
			},

			resumenConPromedio ( item, campo ) {
				if ( !item || !item[campo] ) return 'Sin datos'
				return `${ item[campo] } (${ this.formatearNumero( item.promedio ) })`
			},

			resumenDefault () {
				return {
					promedio_general: 0,
					respuestas_obtenidas: 0,
					alumnos_encuestados: 0,
					total_alumnos: 0,
					porcentaje_participacion: 0,
					peor_categoria: null,
					mejor_categoria: null,
					sucursal_critica: null,
				}
			},

			plantelSeleccionadoTexto () {
				const plantel = this.planteles.find( item => Number( item.id_plantel ) === Number( this.filtroPlantel ) )
				return plantel ? plantel.plantel : 'Todos'
			},

			nivelSeleccionadoTexto () {
				const nivel = this.niveles.find( item => Number( item.id_nivel ) === Number( this.filtroNivelReporte ) )
				return nivel ? nivel.nivel : 'Todos'
			},

			/** id_ciclo ERP según escuela (Inbi vs Fast); acepta objeto ciclo o solo el id numérico */
			idCicloEncuestaSeleccionado () {
				const c = this.ciclo
				if ( c == null || c === '' ) return null
				if ( typeof c === 'number' ) return Number.isFinite( c ) && c > 0 ? c : null
				const idInbi = Number( c.id_ciclo )
				const idRel = c.id_ciclo_relacionado != null && c.id_ciclo_relacionado !== ''
					? Number( c.id_ciclo_relacionado )
					: null
				if ( this.opEscuela === 2 ) {
					if ( Number.isFinite( idRel ) && idRel > 0 ) return idRel
					return Number.isFinite( idInbi ) && idInbi > 0 ? idInbi : null
				}
				return Number.isFinite( idInbi ) && idInbi > 0 ? idInbi : null
			},

   		getCiclos () {
      	this.cargar = true
        this.ciclos = []
        return this.$http.get('ciclos.activos.erp').then(response=>{
        	this.ciclos = response.data.filter( el => !el.ciclo.match('FE') && !el.ciclo.match('INVER') && !el.ciclo.match('CAMBIOS') && !el.ciclo.match('EXCI') )
        	this.cargar      = false
        }).catch( error =>{
          const msg = ( error.response && error.response.data && error.response.data.message ) || error.message || 'Error al cargar ciclos'
          this.validarError( msg )
        }).finally( () => { this.cargar = false })
      },

			exportarExcelReporte () {
				if ( !this.tieneDatosReporte ) {
					this.validarErrorDirecto( 'No hay datos para exportar.' )
					return
				}

				const workbook = XLSX.utils.book_new()
				const hojas = [
					{
						nombre: 'Resumen',
						datos: [ {
							Ciclo: this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : '',
							Escuela: this.opEscuela === 2 ? 'Fast' : 'Inbi',
							'Sucursal filtro': this.plantelSeleccionadoTexto(),
							'Nivel filtro': this.nivelSeleccionadoTexto(),
							'Promedio general': this.promedioGeneralDisplay,
							'Semáforo': this.semaforoPromedioGeneral.label,
							'Participación (%)': this.porcentajeParticipacionDisplay,
							'Peor categoría': this.peorCategoriaDisplay,
							'Mejor categoría': this.mejorCategoriaDisplay,
							'Sucursal crítica': this.sucursalCriticaDisplay,
							'Respuestas obtenidas': this.resumen.respuestas_obtenidas,
							Total: this.alumnos,
							Faltan: this.faltantes.length,
							'Avance (%)': this.avanceFaltantes,
						} ],
					},
					{ key: 'nivel', nombre: 'Nivel y Cat', headers: this.headersNivel, datos: this.mapearDatosExcel( this.headersNivel, this.nivel ) },
					{ key: 'categorias', nombre: 'Categoria', headers: this.headersCategoria, datos: this.mapearDatosExcel( this.headersCategoria, this.categorias ) },
					{ key: 'departamentos', nombre: 'Suc y Cat', headers: this.headersDepartamento, datos: this.mapearDatosExcel( this.headersDepartamento, this.departamentos ) },
					{ key: 'teachers', nombre: 'Teacher y Categoria', headers: this.headersTeachers, datos: this.mapearDatosExcel( this.headersTeachers, this.teachers ) },
					{ key: 'comentarios', nombre: 'Comentarios', headers: this.headersComentario, datos: this.mapearDatosExcel( this.headersComentario, this.comentarios ) },
					{ key: 'avance', nombre: 'Avance', headers: this.headersAvanceExcel, datos: this.mapearDatosExcel( this.headersAvanceExcel, this.avanceAlumnosExcel ) },
					{ key: 'faltantes', nombre: 'Faltantes', headers: this.headersFaltantes, datos: this.mapearDatosExcel( this.headersFaltantes, this.faltantes ) },
					{ key: 'avanceSucursal', nombre: 'Avance sucursal', headers: this.headersAvanceSucursal, datos: this.mapearDatosExcel( this.headersAvanceSucursal, this.avancePorSucursal ) },
					{ key: 'preguntas', nombre: 'Preguntas', headers: this.headersPreguntas, datos: this.mapearDatosExcel( this.headersPreguntas, this.preguntas ) },
				]

				hojas.forEach( hoja => {
					const headers = hoja.headers ? hoja.headers.map( header => header.text ) : null
					const sheet = headers
						? XLSX.utils.json_to_sheet( hoja.datos, { header: headers } )
						: XLSX.utils.json_to_sheet( hoja.datos )
					XLSX.utils.book_append_sheet( workbook, sheet, hoja.nombre )
				} )

				const ciclo = this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : 'sin_ciclo'
				const escuela = this.opEscuela === 2 ? 'FAST' : 'INBI'
				const nombreArchivo = `reporte_satisfaccion_${escuela}_${ciclo}`.replace( /[\\/:*?"<>|]/g, '_' )
				XLSX.writeFile( workbook, `${nombreArchivo}.xls` )
			},

			exportarExcelAvanceSucursal () {
				if ( !this.avancePorSucursal.length ) {
					this.validarErrorDirecto( 'No hay datos de sucursales para exportar.' )
					return
				}
				const workbook = XLSX.utils.book_new()
				const datos = this.mapearDatosExcel( this.headersAvanceSucursal, this.avancePorSucursal )
				const headers = this.headersAvanceSucursal.map( header => header.text )
				const sheet = XLSX.utils.json_to_sheet( datos, { header: headers } )
				XLSX.utils.book_append_sheet( workbook, sheet, 'Avance sucursal' )
				const ciclo = this.ciclo && this.ciclo.ciclo ? this.ciclo.ciclo : 'sin_ciclo'
				const escuela = this.opEscuela === 2 ? 'FAST' : 'INBI'
				const nombreArchivo = `avance_satisfaccion_sucursal_${escuela}_${ciclo}`.replace( /[\\/:*?"<>|]/g, '_' )
				XLSX.writeFile( workbook, `${nombreArchivo}.xls` )
			},

			mapearDatosExcel ( headers, items ) {
				return ( items || [] ).map( item => {
					return headers.reduce( ( row, header ) => {
						row[ header.text ] = this.valorExcel( item[ header.value ], header.value )
						return row
					}, {} )
				} )
			},

			valorExcel ( valor, campo ) {
				if ( valor == null ) return ''
				if ( campo === 'promedio' ) {
					if ( String( valor ).toLowerCase() === 'no aplica' ) return 'No aplica'
					const numero = Number( valor )
					return Number.isFinite( numero ) ? numero : valor
				}
				if ( campo === 'avance' ) {
					const numero = Number( valor )
					return Number.isFinite( numero ) ? numero : valor
				}
				return valor
			},

			initialize ( ) {
				if ( !this.tieneAccesoReporteSatisfaccion ) return
				const idCiclo = this.idCicloEncuestaSeleccionado()
				if ( idCiclo == null ) {
					this.validarErrorDirecto( 'Selecciona un ciclo válido (id de ciclo no disponible).' )
					return
				}
				this.cargar = true
				this.comparativoParticipacion = null
				this.errorComparativo = ''
				this.preguntasPromedioActualApi = []
				this.preguntasPromedioAnteriorApi = []
				this.promediosPlantelActualApi = []
				this.promediosPlantelAnteriorApi = []
				this.cicloAnteriorPreguntasNombre = ''
				this.cicloActualPreguntasNombre = ''
				this.dialogComparativoParticipacion = false
				this.dialogCalificacionGlobalPreguntas = false
				this.dialogPromedioCalificacionSucursal = false
				const payload = {
          id_ciclo : idCiclo,
          iderp    : this.getdatosUsuarioERPERP.iderp,
          idpuesto : this.getdatosUsuarioERPERP.idpuesto,
          planteles: this.getdatosUsuarioERPERP.planteles,
					op_escuela: this.opEscuela,
					id_plantel: this.filtroPlantel || null,
					id_nivel: this.filtroNivelReporte || null,
        };

				this.$http.post('encuestas.satisfaccion.resultados', payload).then(response=>{
					const d = response.data || {}
					if ( this.modoSoloAvance ) {
						this.avanceAlumnos = Array.isArray( d.avanceAlumnos ) ? d.avanceAlumnos : []
						this.planteles = Array.isArray( d.planteles ) ? d.planteles : []
						this.niveles = Array.isArray( d.niveles ) ? d.niveles : []
						this.faltantes = []
						this.categorias = []
						this.comentarios = []
						this.jefe = []
						this.escuela = []
						this.departamentos = []
						this.nivel = []
						this.preguntas = []
						this.teachers = []
						this.alumnosLista = []
						this.alumnos = Number( d.alumnos ) || this.avanceAlumnos.length
						this.avancePorSucursal = []
						this.cicloSiguiente = null
						this.resumen = Object.assign( this.resumenDefault(), d.resumen || {} )
						return
					}
					this.faltantes     = Array.isArray( d.faltantes ) ? d.faltantes : []
					this.categorias    = Array.isArray( d.categorias ) ? d.categorias : []
					this.comentarios   = Array.isArray( d.comentarios ) ? d.comentarios : []
					this.avanceAlumnos = Array.isArray( d.avanceAlumnos ) ? d.avanceAlumnos : []
					this.jefe          = Array.isArray( d.jefe ) ? d.jefe : []
					this.escuela       = Array.isArray( d.escuela ) ? d.escuela : []
					this.departamentos = Array.isArray( d.departamentos ) ? d.departamentos : []
					this.nivel         = Array.isArray( d.nivel ) ? d.nivel : []
					this.preguntas     = Array.isArray( d.preguntasAlumnos ) ? d.preguntasAlumnos : []
					this.teachers      = Array.isArray( d.teachers ) ? d.teachers : []
					this.alumnosLista  = Array.isArray( d.alumnos ) ? d.alumnos : []
					this.alumnos       = this.alumnosLista.length
					this.avancePorSucursal = Array.isArray( d.avancePorSucursal ) ? d.avancePorSucursal : []
					this.cicloSiguiente = d.ciclo_siguiente || null
					this.planteles     = Array.isArray( d.planteles ) ? d.planteles : []
					this.niveles       = Array.isArray( d.niveles ) ? d.niveles : []
					this.resumen       = Object.assign( this.resumenDefault(), d.resumen || {} )
					// Comparativo en segundo plano: no bloquea Reporte sucursal
					this.cargarComparativoParticipacion( payload )
				}).catch( error =>{
					const msg = ( error.response && error.response.data && error.response.data.message ) || error.message || 'Error al cargar el reporte'
					this.validarError( msg )
					this.comparativoParticipacion = null
				}).finally( () => { this.cargar = false })	
			},

			abrirIncidencia ( item, soloLectura ) {
				this.alumnoIncidencia = item
				this.incidenciaSoloLectura = soloLectura
				this.formIncidencia = {
					comentario: item.incidencia_comentario || '',
					archivo: null,
					preview: '',
					evidenciaUrl: item.incidencia_evidencia
						? this.urlEvidencia + item.incidencia_evidencia
						: '',
				}
				this.dialogIncidencia = true
			},

			cerrarIncidencia () {
				this.dialogIncidencia = false
				this.alumnoIncidencia = null
				this.incidenciaSoloLectura = false
				this.formIncidencia = {
					comentario: '',
					archivo: null,
					preview: '',
					evidenciaUrl: '',
				}
			},

			previsualizarIncidencia () {
				const archivo = this.formIncidencia.archivo
				if ( !archivo ) {
					this.formIncidencia.preview = ''
					return
				}
				if ( archivo.size > 26214400 ) {
					this.validarErrorDirecto( 'El archivo sobrepasa el límite de peso, máx. 25 MB' )
					this.formIncidencia.archivo = null
					this.formIncidencia.preview = ''
					return
				}
				const reader = new FileReader()
				reader.onload = ( e ) => {
					this.formIncidencia.preview = e.target.result
				}
				reader.readAsDataURL( archivo )
			},

			subirEvidenciaIncidencia () {
				const formData = new FormData()
				formData.append( 'file', this.formIncidencia.archivo )
				return this.$http.post( 'tickets.subir.evidencia', formData ).then( response => {
					const nombres = Array.isArray( response.data ) ? response.data : []
					if ( !nombres.length ) {
						throw new Error( 'No se pudo subir la evidencia' )
					}
					return nombres[0]
				} )
			},

			async guardarIncidencia () {
				if ( !this.puedeGuardarIncidencia || !this.alumnoIncidencia ) return
				const idCiclo = this.idCicloEncuestaSeleccionado()
				if ( idCiclo == null ) {
					this.validarErrorDirecto( 'Selecciona un ciclo válido.' )
					return
				}
				this.guardandoIncidencia = true
				try {
					const evidencia = await this.subirEvidenciaIncidencia()
					const payload = {
						id_ciclo: idCiclo,
						id_alumno: this.alumnoIncidencia.id_alumno,
						comentario: this.formIncidencia.comentario.trim(),
						evidencia,
						id_usuario: this.getdatosUsuarioERPERP.iderp,
					}
					const response = await this.$http.post( 'encuestas.satisfaccion.incidencia.add', payload )
					const inc = response.data && response.data.incidencia ? response.data.incidencia : null
					const idx = this.avanceAlumnos.findIndex(
						a => Number( a.id_alumno ) === Number( this.alumnoIncidencia.id_alumno )
					)
					if ( idx >= 0 && inc ) {
						this.$set( this.avanceAlumnos, idx, {
							...this.avanceAlumnos[idx],
							id_incidencia: inc.id_incidencia,
							incidencia_comentario: inc.comentario,
							incidencia_evidencia: inc.evidencia,
							incidencia_fecha: inc.fecha_registro,
						} )
					}
					this.validarSuccess( response.data.message || 'Incidencia registrada' )
					this.cerrarIncidencia()
				} catch ( error ) {
					const msg = ( error.response && error.response.data && error.response.data.message )
						|| error.message
						|| 'Error al guardar la incidencia'
					this.validarError( msg )
				} finally {
					this.guardandoIncidencia = false
				}
			},
    }
	}
</script>

<style scoped>
.estatus-ciclo-cell {
  display: flex;
  justify-content: center;
  align-items: center;
  min-width: 96px;
}

.estatus-ciclo-chip {
  font-size: 0.75rem !important;
  font-weight: 600;
  height: 24px !important;
  padding: 0 8px !important;
}

.estatus-ciclo-chip >>> .v-chip__content {
  padding: 0;
  line-height: 1;
}

.avance-estatus-btn.v-btn--disabled {
  opacity: 1 !important;
}

.comparativo-card-ant {
  border-left: 4px solid #7b1fa2 !important;
}
.comparativo-card-act {
  border-left: 4px solid #2e7d32 !important;
}
.comparativo-tabla-wrap {
  overflow-x: auto;
}
.comparativo-tabla {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.8125rem;
}
.comparativo-tabla th,
.comparativo-tabla td {
  border: 1px solid #e0e0e0;
  padding: 6px 8px;
  white-space: nowrap;
}
.comparativo-tabla .th-plantel {
  background: #f5f5f5;
  text-align: left;
  vertical-align: middle;
}
.comparativo-tabla .th-grupo-ant,
.comparativo-tabla .th-sub-ant {
  background: #f3e5f5;
  color: #6a1b9a;
  text-align: center;
}
.comparativo-tabla .th-grupo-act,
.comparativo-tabla .th-sub-act {
  background: #e8f5e9;
  color: #1b5e20;
  text-align: center;
}
.comparativo-tabla .th-grupo-var,
.comparativo-tabla .th-sub-var {
  background: #eeeeee;
  color: #424242;
  text-align: center;
}
.comparativo-tabla .td-ant {
  background: #faf5fc;
}
.comparativo-tabla .td-act {
  background: #f4faf5;
}
.comparativo-tabla .td-var {
  background: #fafafa;
}
.comparativo-tabla .fila-total td {
  font-weight: 700;
  background: #f5f5f5;
}
.comparativo-tabla .fila-total .td-ant {
  background: #ede7f6;
}
.comparativo-tabla .fila-total .td-act {
  background: #c8e6c9;
}
.comparativo-narrativa {
  line-height: 1.45;
}
.tabla-sucursal-calif .estatus-chip {
  display: inline-block;
  min-width: 110px;
  padding: 4px 10px;
  border-radius: 999px;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff;
}
.tabla-sucursal-calif .estatus-urgente { background: #b71c1c; }
.tabla-sucursal-calif .estatus-critico { background: #e65100; }
.tabla-sucursal-calif .estatus-observacion { background: #f9a825; color: #3e2723; }
.tabla-sucursal-calif .estatus-estable { background: #66bb6a; }
.tabla-sucursal-calif .estatus-excelente { background: #2e7d32; }
.tabla-sucursal-calif .estatus-sin { background: #9e9e9e; }
.tabla-sucursal-calif .fila-estatus-urgente td { background: #ffebee; }
.tabla-sucursal-calif .fila-estatus-critico td { background: #fff3e0; }
.tabla-sucursal-calif .fila-estatus-observacion td { background: #fffde7; }
.tabla-sucursal-calif .fila-estatus-estable td { background: #f1f8e9; }
.tabla-sucursal-calif .fila-estatus-excelente td { background: #e8f5e9; }
</style>



